export const ro = {
    addDatabase: {
        addDatabase: "Aduga Baza de Date",
        addFromFile: "Adauga din Fisier",
        analyse: "Analyse",
        analysingYourData: "Analysing your data",
        createFromExcel: "Create from Excel",
        databaseImport: "Database import",
        databaseNotImported: "Import has finished with errors",
        databasePrepared: "Database successfully prepared",
        excelFile: "Excel file",
        fileInformation: "File information",
        fixErrors: "To continue please fix following errors and retry",
        importingYourData: "Importing your data",
        productFilesPath: "Product files path",
        productImagesPath: "Product images path"
    },
    availablePrice: {
        allPackage: "All packages",
        onePackage: "One package",
        priceType: "Tipul de Pret",
        setPriceVatVisibility: "Set VAT visibility",
        setVisibilityAndOrder: "StabiliÈi vizibilitatea Èi ordinea tipurilor de preÈ",
        withAndWithoutVat: "Ambele cu si fara TVA",
        withVat: "Numai cu TVA",
        withoutVat: "Numai fara TVA"
    },
    barvis: {
        base: "Nume bazÄ",
        bigCanSize: "Cutii mari",
        coating: "Vopsea",
        identifier: "Idenficator",
        laboratory: "Laborator",
        orderOverview: "Prezentare generalÄ a comenzii",
        rank: "Rang",
        smallCanSize: "Cutii mici"
    },
    basicSetup: {
        alreadyLoggedIn: "Esti deja logat cu %{login}.",
        askSupplier: "Cere mai multe licente de la provider-ul de software",
        asterisk: "Reperele marcate cu asterix trebuie completate",
        identificationKeys: "Identification keys",
        importCustomData: "Daca se poate,importa datele din software-ul de dispersare anterior",
        learnIdentification: "Invata cheile de identificare de la provider-ul de software",
        login: "Urmatorii pasi pentru setarea initiala au nevoie de aprobarea admin.",
        noDatabase: "Nu a fost adaugata nici o baza de date inca,cel putin una trebuie adaugata.",
        offlineLicensing: "Offline licensing",
        productSelection: "Product selection",
        registrationForm: "Registration form",
        seeQuestionMark: "Vezi semnele de intrebare ca sa inveti mai multe despre setari.",
        selectDefaultPrinter: "Selecteaza imprimanta de baza si seteaza configurarile aditionale.",
        selectDefaultTemplate:
            "Selecteaza modelele de baza din cele existente ,creaza un nou model sau incarca pe cel propriu",
        selectDispenser: "Selecteaza modelul  dispenserului pe care il folosesti.",
        selectLanguage: "Selecteaza limba",
        selectProducts: "Selecteaza unul din produsele valabile pe care vrei sa-l activezi.",
        selectSpectroType: "Selecteaza tipul de spectro pe care il folosesti",
        setAdditionalPrinterOptions: "Seteaza optiunile aditionale ale imprimantei.",
        setAutomaticUpdates: "Seteaza optiunile de update automat.",
        setCustomItems: "Seteaza reperele customizate si datele vizibile.Mergi mai jos pentru mai multe optiuni.",
        setEnvironment: "Seteaza mediul general al sotware-ului.Mergi mai jos pentru mai multe optiuni.",
        setFormulaRepresentation: "Seteaza reprezentarea formulei.Mergi mai jos pentru mai multe optiuni.",
        summary:
            "Poti sa schimbi oricand aceste setari si sa gasesti chiar mai multe optiuni de configurare.Bucura-te ca folosesti %{name}!",
        summarySuccess: "Totul este setat"
    },
    beforeDispenseColorantBatch: {
        batchNumber: "Batch number: %{batchNumber}",
        colorantIsDefective: "The canister is filled with a defective batch of colorant. Do not use this batch.",
        defectiveInfoLine1: "Please do not use colorant",
        defectiveInfoLine2: "with this batch number.",
        emptyQuickTint: "Empty the canister using Quick tint.",
        warningInfoLine1: "Colorant",
        warningInfoLine2: "with this batch number may be damaged."
    },
    canisterLevel: {
        canisterLevel: "Ajustare nivel canistra",
        criticalLevelCanister: "Critical canister levels",
        fillToMax: "Umplere la Maxim",
        maxDispenseLevel: "Disperseaza max",
        otherCanisters: "Alte Canistre",
        warningLevelCanister: "Warning canister levels"
    },
    canisterRefillHistoryModal: {
        batchNumberOfFilling: "Batch number of filling",
        ufiCodeStatus: "UFI code status"
    },
    canistersTab: {
        availableServiceActions: "Actiuni de service valabile",
        canisterInformation: "Informatii despre canistra",
        canisterPreview: "Previzualizare canistre",
        currentLevel: "Nivel Actual",
        errors: "Erori",
        fillState: "Status Umplere",
        fillToMax: "Umplere pana la Max",
        fillingAmount: "Filling amount",
        finalLevel: "Final level",
        minimumAmount: "Nivel Minim",
        minimumLevel: "Nivel Minim",
        moveTableToRefill: "Roteste pozitia canistrelor pentru reumplere",
        refillNoAmount: "Nu a fost introdusÄ nici o valoare",
        refillOverLimit: "Valoarea introdusa depaseste capacitatea max a canistrei",
        refillSummary: "%{amount} %{unit} of the colorant %{colorant} will be added to the canister %{canisterId}.",
        systemWarningAmount: "Nivel de avertizare sistem",
        warningAmount: "Avertizare Nivel"
    },
    changeDatabase: {
        changeDatabase: "Modifica Baza de Date",
        databaseWarning: "Database %{databaseName} cannot be used due to"
    },
    changelog: {
        allVersion: "All versions",
        changelog: "Changelog",
        link: "Link",
        links: "Links",
        version: "Version",
        versionFilter: "Version filter"
    },
    checkBeforeDispensing: {
        checkBeforeDispensingModal: "There is not enough colorant in the canisters for %{numOfPackages} packages.",
        fillAdditionally: "Fill additionally",
        refillToMax: "Refill to max"
    },
    cleanChannels: {
        cleanAllChannels: "Curatare toate circuitele",
        cleanChannels: "Curatare circuite",
        cleaningTime: "Timp de Curatare",
        selectChannels: "Selectare circuite",
        startCleaning: "Incepe Curatarea"
    },
    clientServerSettings: {
        activeServer: "Server Activ",
        addNewServer: "Adauga un nou server",
        availableServers: "Alte Servere disponibile",
        clientIdentifier: "Identificator client",
        clientServerSettings: "Sertare Server",
        disabledStatus: "dezactivat",
        editServer: "Editeaza Server",
        fillRequiredFields: "Campurile cerute trebuie completate",
        noOtherServers: "Nu sunt alte servere disponibile",
        offlineStatus: "offline",
        onlineStatus: "online",
        port: "Port",
        serverName: "Nume Server",
        serverNameMissing: "Numele serverului trebuie completat",
        stabileConnection: "Pentru a asigura o conexiune stabila,foloseste adresa IP statica",
        wrongFormatIp: "Format gresit a adresei IP"
    },
    colorSearchTab: {
        notEveryItemSelected: "One or more items are not selected"
    },
    colorTab: {
        colorTone: "Ton culoare",
        fandeckPosition: "Pozitia paletar",
        moreInfoIcons: "More info icons",
        notExistingFormula: "Formula nu exista",
        orderBy: "Aranjeaza dupa",
        selectYourGrid: "Selecteaza grid",
        showInPanel: "Arata in tablou",
        warningIcon: "atentionare ca Formula nu exista "
    },
    colorantBatchNumberSettings: {
        batchNumberByPercentage: "Use Batch numbers by percentage",
        batchNumberFromLastFilling: "Use Batch numbers from the last filling",
        defectiveBatchOfColorant: "Defective Batch of colorant",
        enableBatchNumber: "Enable colorant Batch numbers",
        possibleDamagedBatchOfColorant: "Possibly damaged Batch of colorant",
        scanOrTypeBatchNumber: "Scan or type Batch number"
    },
    colorantPanel: {
        manualMachine: "machine"
    },
    colorantsTable: {
        numberOfColorants: "Numarul Colorantului",
        preview: "Î ÏÎ¿ÎµÏÎ¹ÏÎºÏÏÎ·ÏÎ·",
        prices: "Preturi"
    },
    currencySettings: {
        addNewCurrency: "Adauga o noua Moneda",
        codePlaceholder: "Cod",
        currencySettings: "Setare Moneda",
        namePlaceholder: "Nume ",
        ratePlaceholder: "Rata ",
        setDecimalPlaces: "Setare numar zecimale",
        setMainCurrency: "Setare Moneda Principala",
        setRounding: "Setare rotunjime numar",
        symbolPlaceholder: "Simbol"
    },
    customFandecks: {
        customFandecks: "Paletar Personalizat",
        deleteButtonWarning: "All formulas in fandeck will be removed too.",
        deleteCustomFandeck:
            "Do you really want to delete this custom fandeck? All formulas in this fandeck will be deleted too.",
        disableStandardFandecks: "Show only custom fandecks",
        enableStandardFandecks: "Show standard fandecks",
        fandeckName: "Nume paletar"
    },
    customRedlike: {
        addColorantFromBrand: "Add colorant from %{brandName} brand",
        addNewCustomer: "AdÄugaÈi un client nou",
        addNewNote: "AdÄugaÈi o notÄ nouÄ",
        addedDate: "Data adÄugatÄ",
        addedQuantity: "Cantitate adÄugatÄ",
        availableMachine: "MaÈinÄ disponibilÄ",
        brand: "Marca",
        brandPlease: "VÄ rugÄm sÄ selectaÈi marca",
        cancelCustomer: "AnulaÈi clientul",
        colorPlease: "VÄ rugÄm sÄ selectaÈi culoarea",
        confirmCustomerData: "ConfirmaÈi datele clienÈilor",
        confirmNoteData: "ConfirmÄ datele notelor",
        confirmSelectedUser: "Vrei sa folosesti numele clientului %{customerName} pentru aceasta comanda.",
        confirmed: "Confirmat",
        controlData: "Controlul final al datelor",
        customerCellNumber: "NumÄrul mobil al clientului",
        customerFilter: "Filtrul clienÈilor",
        customerName: "Numele clientului",
        customerPhone: "Telefon client",
        customerPlease: "VÄ rugÄm sÄ selectaÈi clientul",
        dateFilter: "Filtrul de date",
        enterPin: "IntroduceÈi codul dvs. pin",
        enterTheNumberOfPackages: "IntroduceÈi numÄrul de ambalaje",
        existingCustomer: "User Already Exists",
        fandeckPlease: "Selecteaza paletar de culori",
        fillCanisterHistory: "Introdu i istoricul canistrei",
        findCustomer:
            "Pentru a aloca cardul de fidelitate acestei comenzi, vÄ rugÄm sÄ scanaÈi codul de bare sau sÄ cÄutaÈi adresa de e-mail",
        findCustomerByEmail: "FiltreazÄ clientul prin e-mail sau cod de bare",
        finishPreviousStep: "(VÄ rugÄm sÄ terminaÈi pasul anterior)",
        formulaUnit: "Unitatea de formulÄ",
        getBackToList: "ReveniÈi la lista de clienÈi",
        historyOfOrders: "Istoricul comenzilor",
        insertNote: "AccesaÈi nota",
        loadHistoryOrder: "DoriÈi sÄ Ã®ncÄrcaÈi comanda selectatÄ?",
        loyaltyCards: "Card de loialitate",
        machineIsAvailable: "MASINA ESTE DISPONIBILÄ",
        machineIsUnavailable: "MaÈina este inaccesibilÄ",
        newLoyaltyCard: "Nou card de fidelitate",
        noAvailableMachine: "MaÈina nu este disponibilÄ",
        noCustomerSelected: "No customer is selected. Do you want continue?",
        notePlease: "VÄ rugÄm sÄ introduceÈi notÄ",
        openHistory: "Deschide Istoric ",
        orAdd: "sau adÄugaÈi client",
        orSelect: "sau selectaÈi clientul",
        orderModification: "The original order will be modified. Do you want to continue?",
        orderOverview: "Prezentare generalÄ a comenzii",
        orderToMachine: "TRIMITE COMANDA CATRE MASINA",
        ordersHistory: "Istoricul comenzilor",
        packagePlease: "VÄ rugÄm sÄ selectaÈi ambalajul",
        pleaseSelectBrand: "VÄ rugÄm sÄ selectaÈi Marca",
        previewImage: "Previzualizare IMG",
        previewPackage: "Previzualizarea ambalajului",
        productPlease: "VÄ rugÄm sÄ selectaÈi produsul",
        resetFilters: "ResetaÈi toate filtrele",
        searchForHistoricalOrders: "Sau cÄutaÈi comenzi istorice",
        selectBrand: "Te rog selecteaza Marca",
        selectColor: "MergeÈi pentru a selecta culoarea",
        selectCustomer: "MergeÈi pentru a selecta client",
        selectExistingCustomer: "SelectaÈi clientul existent",
        selectFandeck: "MergeÈi pentru a selecta paletarul de culori",
        selectManually: "If you want to use this color in %{brandNames} brand, please select it manually.",
        selectPackage: "AccesaÈi ambalajul selectat",
        selectProduct: "AccesaÈi produsul selectat",
        shotsCoefficient: "Coeficient shots",
        showDetail: "AratÄ detalii",
        showHideEshopName: "Show/Hide the eshop name of the color in a separate column",
        showKeyboard: "AfiÈeazÄ tastatura",
        skipCustomerButton: "skip select customer",
        skipCustomerText: "Salt dacÄ nu doriÈi sÄ introduceÈi un client",
        skipNote: "Treci de notÄ Èi vizualizeazÄ rezumatul",
        spectroBrand: "Searching in brand %{brandName}",
        statusAccepted: "admis",
        statusCanceled: "anulat",
        statusCreated: "creatÄ",
        statusDone: "Terminat",
        statusPartlyDone: "parÈial fÄcut",
        statusPreparing: "pregÄtirea",
        summaryChosenBase: "baza",
        summaryChosenBrand: "marca",
        summaryChosenCanSize: "marime cutie",
        summaryChosenColor: "culoare",
        summaryChosenColorCard: "Paletar de culori",
        summaryChosenProduct: "produs",
        summaryChosenQuantity: "cantitate",
        summaryColorPreview: "color preview",
        summaryCustomNote: "NotÄ personalizatÄ",
        summaryCustomerNumber: "numarul clientului",
        summaryFormula: "formulÄ",
        summaryFormulaNote: "NotÄ de formulÄ",
        summaryNote: "NotÄ",
        sureAboutSend: "Sigur doriÈi sÄ trimiteÈi o comandÄ?",
        useCustomerInOrder: "Vrei sa folosesti %{customerName} in urmatoarea comanda?",
        uuid: "Uuid",
        viewSummary: "Vizualizeaza sumar",
        volume: "volume"
    },
    customRedlikeAnother: {
        pinOrderConfirmation: "Confirmare Pin comanda",
        pinScreenSaverConfirmation: "Confirmare Pin screensaver",
        pinSettingsConfirmation: "Confirmare Pin setari",
        printAuto: "Permite printare automata",
        printerSettings: "Setare imprimanta",
        selectColorWithFandeck: "Setari uzuale culoare sau paletar de culori",
        setKeyboard: "SetaÈi tastatura",
        setKioskMode: "SetaÈi modul chioÈc",
        setLanguage: "SeteazÄ limba",
        setModule: "Seteaza modul",
        setQuickSelect: "SetaÈi selectarea rapidÄ",
        setScreensaverTimeout: "SetaÈi timp inchiderea ecranului",
        setUnit: "Seteaza unitate"
    },
    customRedlikeMachine: {
        action: "AcÈiune",
        additionalPrint: "TipÄrire suplimentarÄ",
        brand: "Marca",
        brandAccess: "Utilizatorul %{userName} nu poate accesa datele de la marca %{brandName}",
        can: "Cutie asezata",
        canistersLevel: "Prezentare generalÄ a nivel de canistre",
        closeDetailInformation: "Detaliu apropiat",
        colorantsAmount: "Cantitate ColoranÈilor",
        confirmRefill: "ConfirmaÈi reumplerea de coloranÈi",
        deleteOrder: "ÈtergeÈi comanda",
        dialogNoMachine: "Aparatul nu este conectat",
        dialogNoRcc: "Nu este conectat niciun RCC",
        dispense: "Dispenseaza",
        dispenserInErrorState: "Dispenserul este Ã®n stare de eroare",
        dispensingIsOk: "Dispenserul este OK",
        emergencyButtonPressed: "Emergency button pressed",
        errorCode: "Cod de eroare",
        errorEvents: "Erorile dispenserului",
        errorReset: "Resetare eroare",
        explanation: "ExplicaÅ£ie",
        imageNotAvailable: "Imaginea nu este disponibilÄ",
        incorrectCanister: "Scanere incorecta a canistrei!",
        incorrectColorant: "ERROR: Incorrect colorant scanned. Please scan correct colorant",
        lastEvents: "Ultimele evenimente",
        machineActions: "Dispenser status",
        machineConfiguration: "ConfiguraÈia dispenserului",
        machineError: "Eroare a maÈinii",
        machineIsBusy: "MaÈina este ocupatÄ",
        machineNotAvailable: "MaÈina nu este disponibilÄ",
        machineTinting: "Please wait, machine tinting...",
        manualScan: "Scanare manualÄ",
        notEnoughSpace: "EROARE:Nu este suficient spatiu pentru acest ambalaj de colorant",
        numberOfCanistersUnderCriticalLevel: "Numarul de canistre sub nivelul critic este %{0}",
        numberOfCanistersUnderWarningLevel: "Numarul de canistre sub nivelul de avertizare este %{0}",
        offlinePressed: "Butonul Offline apasat",
        orderSettings: "Setare comenzi",
        otherOrderInformation: "Delaii comanda",
        packageCount: "Numar ambalaj",
        packageWithSeparator: "Ambalaj",
        received: "Primit",
        receivedOrders: "Comenzi primite",
        receivedTime: "Primite de ",
        recirculation: "Recirculare",
        refillInformation: "Colorant: %{0}, Umplere: %{1}, Canistra: %{2}",
        resetErrors: "Reseteaza erori",
        scanCanister: "Scaneaza aceasta canistra",
        scanColorantPackage: "Scan proper colorant package",
        selectedOrder: "Selecteaza comanda",
        shelfMovingDown: "Miscare raft in jos",
        shelfMovingUp: "Miscare raft in sus",
        solution: "Solutie",
        startDispensing: "Incepe dispersia",
        stirring: "Amestecare",
        touchToStartFilling: "Atinge ca sa inceapa umplerea colorantului",
        unknownBrand: "Brand necunoscut"
    },
    customRedlikeSettings: {
        addPos: "Pos Info",
        addServer: "Adauga server",
        adminOperations: "Admin operations",
        adminSettings: "Setari admin",
        another: "Altul",
        aslOrService: "ASL sau service",
        availableMachines: "Masini disponibile",
        barcode: "Cod de bare",
        basicOperations: "Operatii de baza",
        canisterBarcodes: "Cod de bare canistra",
        canisterLevels: "Nivel canistra",
        closeConnection: "Close connection",
        closeRedlike: "Inchide %{name}",
        databaseList: "Baza de date",
        disabledStatus: "dezactivat",
        dispenseLogicType: "Tip de dispersie logica",
        dropServers: "Servere cazute",
        editServer: "Editeaza sever",
        lastEvent: "Ultimul eveniment",
        logOut: "Dezactivati",
        machineConfiguration: "Configurare",
        maxDispenseAmount: "Nivel max de dispersie",
        offlineStatus: "offline",
        onlineStatus: "online",
        openFrondesk: "Deschideti frontdesk",
        print: "Setare imprimanta",
        rebootPC: "Restarteaza PC",
        restartRedlike: "Restart %{name}",
        restoreConnection: "Reinitiaza conexiunile",
        scanCanisterBarcode: "Scaneaza cod de bare",
        scanOrDeleteCanisterBarcode: "Scaneaza sau sterge codul de bare",
        setCanisterBarcode: "Set canister barcode",
        swVersion: "Versiune software",
        systemFunctions: "Functiuni sistem",
        userSettings: "Setari utilizator"
    },
    customTab: {
        cifCombinationCheck:
            "The color %{colorName} already exists in fandeck %{fandeckName}, but it contains different spectral data. Would you like to overwrite existing data?",
        editColor: "Personalizeaza",
        editColorant: "Ambalaj",
        emptyColorant: "There is colorant with empty amount",
        formulaCombinationCheck:
            'The formula with the color name "%{colorName}" already exists. Would you like to overwrite existing formula with the new one?',
        formulaForMasterProduct: "Formula for master product",
        formulaForMasterProductWithParam: "Formula for master product %{productName}",
        isNotAvailable: "Editeaza Culoarea",
        noBaseSelected: "Este necesara baza",
        noColorantsSelected: "Nici un colorant selectat",
        noFandeckSelected: "Este necesar paletarul de culori",
        noNameOrCode: "Color name and code are required",
        noProductSelected: "Produsul este necesar",
        productPreview: "Nu este valabil",
        saveCustomRecipe: "ÎÏÎ¿Î¸Î®ÎºÎµÏÏÎ· ÏÏÎ¿ÏÎ±ÏÎ¼Î¿ÏÎ¼Î­Î½Î·Ï ÏÏÎ½ÏÎ±Î³Î®Ï",
        saveIsNotAvailable: "Salvarea nu este posibila",
        showSiblingProducts: "Show sibling products",
        siblingProducts: "Sibling products by master product"
    },
    customersTab: {
        addCustomer: "Adauga Client",
        additionalSettings: "Additional Settings",
        adress: "Adresa   ",
        createAndSelect: "Create and select",
        createNewCustomer: "Creaza un nou client",
        editCustomer: "Editeaza Client",
        expiration: "Customer %{name} will expire in %{dayCount} days",
        identificationNumber: "Identification number",
        information: "Informatii contact",
        listOfCustomers: "Lista clienti",
        rabat: "Reducere",
        selectCustomer: "Selecteaza client",
        spentLastMonth: "Valoare ultima luna",
        spentMoney: "Valoare",
        typeOfMargin: "Tipul de Margine de Profit",
        zipCode: "Cod postal"
    },
    dialog: {
        cheaperColorSearch: "Cheaper color search is in progress",
        competitiveColorSearch: "Se cauta culoarea competitiva",
        reallyChangeModule: "Chiar vrei sa schimbi modulul?",
        reallyCloseRedlike:
            "Chiar vrei sa inchizi %{name}? Toate %{name} ferestrele se vor inchide, modificarile nesalvate se vor pierde.",
        reallyDeleteOrder:
            "Chiar vrei sa stergi aceasta comanda?Toate datele referitoare la acesta comanda se vor pierde.",
        reallyRebootPC:
            "Chiar vrei sa restarezi PC? Toate ferestrele se vor inchide, modificarile nesalvate se vor pierde.",
        reallyRestartRedlike:
            "Chiar vrei sa restarezi  %{name}? Toate ferestrele se vor inchide, modificarile nesalvate se vor pierde.",
        reallyShutdownPc:
            "Chiar vrei sa sa inchizi acest computer? Toate %{name} ferestrele se vor inchide, modificarile nesalvate se vor pierde.",
        unlockComputer: "Computer will be unlocked."
    },
    dispenseLogicTypes: {
        1: "Disperseaza numai cantitatea maxima de colorat",
        2: "Permite dispersarea manuala folosind scala pentru cantitati mai mari decat cantitatea maxima de colorat",
        3: "Reumplere in timpul dispersiei(imparte cantitatea in mai multe cantitati mai mici)",
        4: "Force manual dispensing using scale only in case of custom package"
    },
    editCustomFandeck: {
        fandeckName: "Nume paletar"
    },
    editFormulaRgbModal: {
        apply: "Aplica",
        blue: "Albastru",
        green: "Verde",
        modalLabel: "Editeaza Culoarea",
        red: "Rosu",
        tryGenerateRgb: "Try to generate RGB by colorant amounts"
    },
    environmentsSettings: {
        allowAutoCloseTab: "Close formula tab automatically",
        allowBarcodes: "Permite coduri de bara",
        allowBuildingSitePanel: "Allow building site specification",
        allowCustomers: "Permite clienti",
        allowDeleteConfirmation: "Permite anulare confirmare",
        allowDiskSpaceNotification: "Allow disk space notification",
        allowDispensing: "Permite dispersare",
        allowFileTransfer: "Allow automatic file transfer",
        allowFormulaModificationPanel: "Allow formula modification panel",
        allowFormulaStatusPanel: "Allow formula status panel",
        allowInternalNotes: "Allow internal notes",
        allowLight: "Permite %{name}",
        allowOrderNotificationModal: "Arata nofificari pentru comenzi noi",
        allowOrdering: "Permite comandarea",
        allowPricing: "Permite preturi",
        allowPrint: "Allow print",
        allowProductPreviewImage: "Permite previzualizarea imaginii in timpul dispersiei",
        allowQualityControl: "Allow quality control",
        allowSearchCheaperColors: "Allow searching for cheaper colors",
        allowSound: "Allow sound notification",
        allowSpectro: "Permite spectro",
        allowTabs: "Allow tabs",
        applyZoom: "Aplica zoom",
        automaticLogout: "Automatic logout",
        barcodeScan: "Barcode Scan",
        canisterBarcode: "Canister barcodes",
        canisterLevel: "Canister level",
        changelog: "Schimba logarea",
        closeTab: "Inchide Tab",
        colorDifference: "Color difference",
        colorPanelNavItem: "Color Palette",
        competitiveColorSearch: "Cautare culoare competitiva",
        customBanner: "Banner customizat",
        customCurrencyFormat: "Currency format",
        customDateFormat: "Date format",
        customNumberFormat: "Number format",
        customTimeFormat: "Time format",
        deltaA: "Delta A",
        deltaB: "Delta B",
        deltaE: "Delta E",
        deltaL: "Delta L",
        deltaMetamerism: "Delta metamerism",
        discount: "Show discount",
        dispensingHistory: "Dispensing History",
        dispensingNotes: "Permite notificari dispersie",
        enableCustomers: "Activeaza client",
        enableDeleteConfirmation: "Activeaza stergere confirmare",
        enableDispensing: "Activeaza dispersie",
        enableLight: "Activeaza %{name}",
        enableMarginMarkup: "Activeaza margini sau adaos",
        enableNotes: "Activeaza note",
        enableOrdering: "Activeaza comandarea",
        enableProductPreviewImage: "Activeaza previzualizare imagine produs",
        enableSpectro: "Activeaza spectro",
        enableVirtualKeyboard: "Permite keyboard virtual",
        environmentsSettings: "Setari ambientale",
        exportTranslationKeys: "Exporta cheile de traducere",
        formulaNotes: "Permite note formula",
        hintTooltips: "Sugestie Instrumente",
        image: "Imagine",
        keyboardShortcuts: "Keyboard Shortcuts",
        languageBased: "Language based",
        lockYourComputer: "Blocheaza-ti computerul",
        machineReset: "Machine reset",
        manageTranslations: "Manageriaza traducerile",
        margin: "Numai margini",
        markup: "Numai adaos",
        matchingRowCount: "Set number of results found",
        maxNumberTabs: "Numarul de formule tab",
        memoryTabs: "Store recently opened tabs",
        moreInfo: "Culoare + Imagine + Mai multe info",
        navigationItems: "Setare instrumente navigare",
        newTab: "Tab nou",
        numberOfPriceGroups: "Number of price groups",
        order: "Comanda",
        orderId: "ID comanda",
        ordersHistory: "Istoric comenzi",
        overwriteLastTab: "Overwrite last formula tab",
        priceCalculation: "Price calculation",
        priceDefBothPurchasePrimary: "Both, purchase primary",
        priceDefBothSellPrimary: "Both, sell primary",
        priceDefPurchaseOnly: "Purchase price only",
        priceDefSellOnly: "Sell price only",
        priceDefinition: "Price definition",
        priceGroupsEnabled: "Enable price groups",
        runLightAtStartUp: "Run %{light} la startup",
        screenSaverTimeout: "Screensaver timeout",
        selectedSpectro: "Selected %{spectro} spectro.",
        selectedSpectroNone: "No spectro selected.",
        setAutomaticClientStart: "Run %{name} la startup computer",
        setCustomHomeButton: "Seteaza buton Acasa",
        setDecimalPlaces: "Setare numar zecimale",
        setFormulaPreview: "Alegeti previzualizare Formula",
        setFormulaUnit: "Seteaza unitatea formulei",
        setFts: "Folosete cautare completa dupa text",
        setInfoItemInRgb: "Set visible information in the formula RGB preview",
        setKeyboardShortcuts: "Seteaza keyboard shortcuts",
        setKioskMode: "Seteaza kiosk mod",
        setKioskModeOff: "Inchide kiosk mod",
        setKioskModeOn: "Deschide kiosk mod",
        setNavigationItems: "Setare repere de navigare",
        setNavigationItemsList: "Seteaza vizibilitatea si comanda instrumentele de navigare",
        setOrderSearchItems: "Seteaza parametrii de cautatre a comenzii",
        setRounding: "Setare rotunjime numar",
        setSearchParameters: "Seteaza parametrii de cautare a formulei",
        setTabLimit: "Seteaza limita de Tab-uri",
        setYourLanguage: "Setare Limba",
        setZoom: "Setare zoom",
        showLocalPrices: "Show local prices",
        skipPlaceCanDialogEnabled:
            "Aceasta setare nu poate fi schimbata pentru ca mesajul de plasare a cutiei a fost dezactivat in setarile masinii",
        sortItems: "Sorteaza instrumentele de navigare",
        startDispensing: "Incepe dispersia",
        stir: "Amesteca"
    },
    error: {
        errorDetail: "Detalii eroare",
        errorOccurred:
            "An unexpected error occurred. Contact our support at %{0}, and we'll get back to you as soon as we can.",
        hideDetail: "Ascunde Detalii"
    },
    favoritesTab: {
        addFolder: "Adauga Fisier",
        closeTabToLoadFormula: "Inchide Fereastra ca se incarce formula",
        deleteFolder: "Sterge Fisier",
        editFolder: "Editeaza Fisier",
        favoriteFormulas: "Formule Favorite",
        formulaNotes: "Notele formulei",
        message: {
            formulasFromFolder: "Formula din Fisier",
            moveAllFormulas: "Muta toate formulele",
            removeAllFormulas: "Sterge toate formulele",
            wantToDeleteFolder: "Sterge Fisier"
        },
        newFolder: "Fisier Nou",
        packages: "Ambalaje",
        pricePerPackage: "Pret per ambalaj",
        regularPrice: "Pret Standard",
        removeFromFavorites: "Sterge din Favorite",
        specialPriceOff: "Special price %{number}% off",
        specialPriceVIP: "Pret Special VIP"
    },
    fileTransfer: {
        afterImport: "After import",
        alreadyExists: "Task for given type and format already exists",
        customFormulaSimple: "Custom formula simple",
        direction: "Direction",
        exportTask: "File export task",
        fileTransferNotification: "File transfer notification",
        flashMessage: "Flash message",
        importTask: "File import task",
        noInformation: "No information",
        protocol: {
            folder: "Folder",
            ftp: "FTP protocol",
            ftps: "FTPS protocol",
            redlikeStorage: "%{softwareName} FTP storage protocol",
            sftp: "SFTP protocol"
        },
        protocolDescription: {
            folder: "Protocol checking files in defined local folder.",
            ftp: "Protocol checking files in remote FTP folder using standard FTP connection.",
            ftps: "Protocol checking files in remote FTPS (FTP-SSL / FTP Secure) server using standard FTP connection.",
            redlikeStorage: "Protocol checking files in %{softwareName} storage."
        },
        remoteFolder: "Remote folder",
        startType: "Start type",
        statusbar: "Statusbar information",
        testConnection: "Test connection",
        xMoreLeft: "(%{amount} more left)",
        xmlImporting: "XML file is being imported"
    },
    filtering: {
        consumptionType: "Consumption type",
        filter: "Filtru",
        from: "De la",
        to: "Catre"
    },
    findText: {
        findTextTitle: "Find text",
        removeMarks: "Remove marks",
        search: "Search word"
    },
    flashMessage: {
        VMNotAllowed: "VM not allowed",
        addedToStock: "Successfully added items to stock",
        allRecordsDeleted: "All imported records were successfully deleted",
        autologinFailed: "Database autologin failed.",
        autotaskDuplicateName:
            "Database integrity error: %{0} item with %{1} %{2} already exists, please use different %{3}",
        barcodeIsUsed: "The barcode is already used.",
        barcodeNotFound: "Nu s-a gasit codul de bare",
        bugReportSent: "Your bug report was sent.",
        cannoctConnectToServer: "Nu se poate conecta la server",
        cannotWriteLicense: "Cannot write license",
        clientConnectionRejected: "Conectare refuzata",
        clientNotLoggedIn: "Clientul nu este autentificat",
        colorFromInactiveDatabase: "Color is from inactive database %{0}.",
        colorantPackageRemovedStock: "Colorant package successfully removed from stock.",
        competitiveSearchEmpty:
            "No competitive colors could be found. Change searching parameters or select a different color.",
        competitiveSearchSelectProduct: "Please select product to start competitive color search.",
        computerBackdated: "Computer backdated",
        connectionFailed: "Connection test failed: %{0}",
        connectionSuccess: "Connection test was successful",
        corruptedLicenseFile: "License file corrupted",
        customFormulaCreated: "Custom formula successfully created.",
        customFormulaCreationError: "Error while creating custom formula.",
        customFormulaFromXmlCreationError:
            "Error while creating custom formula with colorants '%{colorants}' for combination of product '%{product}', fandeck '%{fandeck}', color '%{color}' and base '%{base}'.",
        customerNotFound: "The customer was not found",
        dataNotAvailable: "Server cannot connect to database",
        datacolorMatching: {
            couldNotConnect: "Could not connect to Datacolor Matching, either server down or PC is offline.",
            disabled: "Datacolor Matching disabled.",
            internalError: "Datacolor Matching internal error: '%{0}'",
            invalidCredentials: "No or invalid credentials for Datacolor Matching provided, contact database provider.",
            noCansAvailable: "No cans available for selected color file (product line), contact database provider."
        },
        defaultMessage: "Eroare neasteptata de la ultima activitate a serverului",
        deleteAll: "Delete all",
        deletingImportedData: "Deleting imported records.",
        disableWinterPlugin:
            "You can disable the winter plugin by using the drop-down list on the right side of the tab navigation",
        duplicateBarcode: "Duplicate barcode already exists.",
        duplicateName: "Copiati Numele existente",
        emptyFandeck: "Selected fandeck is empty.",
        emptyStock: "There are no records in stock for the item you have used.",
        expiredLicense: "License has expired",
        exportSuccess: "Data have been exported successfully",
        fandeckExist: "Numele paletarului customizat exista deja.",
        featureNotAutorized: "Feature not autorized",
        fileExportComplete: "Fisierul a fost exportat cu succes",
        fileExportError: "An error occurred during file export.",
        fileSaveComplete: "File was successfully saved.",
        fileSaveError: "An error occurred during file saving.",
        fileTransferCustomFormulaRecordsAdded: "New custom formula records were added from the received file.",
        fileTransferCustomFormulaRecordsNotFullyProcessed:
            "Could not fully process custom formula data in file: '%{0}', see error log files for more info.",
        fileTransferCustomFormulaRecordsProcessed:
            "The new custom formula records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferCustomerRecordsAdded: "New customer records were added from the received file.",
        fileTransferCustomerRecordsNotFullyProcessed:
            "Could not fully process customer data in file: '%{0}', see error log files for more info.",
        fileTransferCustomerRecordsProcessed:
            "The new customer records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferFileNotProvided: "File not provided or is empty.",
        fileTransferHistoryRecordsAdded: "New dispensing history records were added from the received file.",
        fileTransferHistoryRecordsNotFullyProcessed:
            "Could not fully process dispensing history data in file: '%{0}', see error log files for more info.",
        fileTransferHistoryRecordsProcessed:
            "The new history records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferInvalidFile: "Could not process data in file, file is not valid.",
        fileTransferOrderRecordsAdded: "New order records were added from the received file.",
        fileTransferOrderRecordsNotFullyProcessed:
            "Could not fully process order data in file: '%{0}', see error log files for more info.",
        fileTransferOrderRecordsProcessed:
            "The new order records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferUnknownVersion: "Could not detect version of file.",
        filetransferNoData: "No database connection, check settings",
        formulaDataUnavailable: "Formula data is not available",
        helperDefaultMessage: "An unexpected error occurred during the last Helper Server action",
        helperServerError: "Helper Server error",
        importAborted: "Import process has been aborted",
        importSuccess: "Data have been imported successfully",
        incompatibleBaseCan: "Ambalajul nu se regaseste conform datelor despre produs,baza si ambalaj",
        incorrectPassword: "Your old password is not correct. Please enter a correct one.",
        invalidCurrency: "Currency code is not valid. Euro is set as a default currency.",
        invalidDatabaseName: "Baza de date nu este valida",
        invalidEmail: "Adresa de email nu este valida",
        invalidFormulaColorants:
            "There is the software issue in the formula. Formula could be wrong! Contact your support!",
        invalidLicenseCompanyUserKey: "Invalid company-user key",
        invalidLicenseFile: "Invalid license file",
        invalidLicenseIdentificationKeys: "Your license identification keys are not valid",
        invalidLicenseKey: "Cheia de Licenta nu este valida",
        invalidLicenseProduct: "License file does not match the product",
        invalidRccResponse: "An unexpected error occurred during processing of the last RCC response",
        invalidServerResponse: "Eroare neasteptata de la ultima procesare a serverului",
        invalidUrl: "URL nu este valid",
        itemNotFound: "Reperul nu a fost gasit",
        keyboardShortcutUsedInModal:
            "This keyboard shortcut cannot be used in the modal window. Please close the modal window.",
        keyboardShortcutValidation: "You cannot have same keyboard shortcut for two different actions",
        licenseHasBeenRevoked: "Licenta a fost revocata.Ca sa o reinoiesti,ia legatura cu provider-ul de software.",
        licenseProlongationNeeded:
            "E nevoie de prelungirea licentei(conecteaza-te la internet pentru a obtine o noua licenta)",
        licenseUpToDate: "Your license is up to date. No update necessary.",
        licenseUpdateUnsuccessful: "Could not update license.",
        licenseUpdated: "License has been successfully updated.",
        licensedOnDifferentComputer: "Originally licensed on a different computer",
        logFileArchiveDownloadComplete: "Downloading of log archive was successfully completed",
        loginError: "Eroare neasteptata de autentificare",
        logoutError: "Eroare neasteptata de iesire ",
        machineIsConnecting: "Machine is connecting, please wait",
        machineIsNotConnected: "Masina nu este conectata la RCC.Verificati Configurarea RCC",
        malformedFormula: "Formula is malformed.",
        matching: {
            correctionNotPossible: "Correction cannot be done, use reformulation.",
            forbidden: "Request '%{0}' failed: forbidden.",
            internalServerError: "Internal server error.",
            invalidBase: "Invalid base in product.",
            invalidBipp: "Invalid base in product package.",
            invalidColorantId: "Invalid colorant with ID: %{0}.",
            invalidColorantName: "Invalid colorant with name: %{0}.",
            invalidColorfile: "Invalid color file with ID: %{0} for product with ID: %{1}.",
            invalidIlluminant: "Invalid illuminant: %{0}",
            invalidProduct: "Invalid product with ID: %{0}.",
            invalidSpectralCurve: "Invalid spectral curve.",
            noColorfiles: "No color files defined for product with ID: %{0}.",
            notAuthorized: "Request '%{0}' failed: unauthorized.",
            notFound: "Request '%{0}' failed: not found.",
            reformulationNotPossible: "Reformulation cannot be done.",
            unknownError: "Unknown error.",
            validationError: "Request '%{0}' failed due to validation errors: %{0}."
        },
        maxFileSizeExceeded: "Maximum file size of %{0} MB exceeded",
        maxTabs: "Numar Maxim de ferestre,va rugam inchideti una.",
        noTemplate: "Printarea nu se poate realiza,nici un template valabil",
        openNewTab: "Please open a new formula tab to load formula using barcode",
        orderAlreadyAcquired: "Order has been already acquired, it has to be released first",
        orderCreated: "Comanda trimisa cu succes",
        passwordIsNotUnique: "Old password must differ from the new one.",
        printCannotBeCarriedOut: "Printarea nu se poate realiza,imprimanta nu are nume valabil",
        problemWithFileExport: "A aparut o eroare in timpul salvarii fisierului pe disc.",
        productFileWarning: "Product file is only available online.",
        productNotLicensed: "Product is not licensed",
        rccDefaultMessage: "Eroare neasteptata de la ultima activitate a RCC",
        rccError: "Eroare RCC",
        rccNeedRestart: "Reporniti RCC",
        restoredSettings: "Settings have been restored.",
        revokedLicense: "License was revoked",
        runningOutOfSpace: "The computer is running out of free space.",
        savedFormulaToHistory: "Formula was successfully saved into history.",
        savedLogArchive: "Log archive was successfully saved into your directory.",
        scanning: "Scanning in progress",
        serverError: "Eroare Server",
        setClientIdentifier: "Please set your client identifier",
        showLess: "Arata mai putin",
        showMore: "Arata mai mult",
        spectroIsDisconnecting: "Spectro is disconnecting, please wait",
        spectroIsNotConnected: "Spectro neconectat.Verificati Configurare RCC",
        spectroIsNotSelected: "Spectro neselectat.Verificati Configurare RCC",
        tmcNotAvailable: "%{tmc} is not available. Please check your %{collector}.",
        tmcNotConnected: "%{tmc} is not connected. Please start your %{collector} and restart server.",
        unknownError: "Eroare necunoscuta: %{0}",
        userAlreadyLoggedIn: "Sunteti autentificat",
        versionNotAllowedByLicense: "Software version is too new and is not allowed for your license.",
        webApiConnectionError: "Could not connect to Web Api server",
        webApiInternalError: "Web Api server internal error",
        webApiInvalidUser: "Web Api server invalid user",
        webApiNoLicenseAvailable: "Web Api server no license available",
        wrongDataSaved: "Wrong data was saved to XML file in the %{0} folder.",
        wrongHelpInput: "Format gresit al %{0} inregistrarii.",
        wrongRccVersion: "Verificati versiunea RCC. Clientul este compatibil numai cu RCC %{0}."
    },
    footer: {
        aboutApplication: "About application",
        activeUser: "Active user",
        logOut: "Iesire",
        machineErrors: "Eroare masina"
    },
    formulaProperties: {
        exterior: "Exterior",
        interior: "Interior",
        invalid: "Invalid",
        solvent: "Solvent based",
        universal: "Universal",
        water: "Water based"
    },
    formulaSettings: {
        allUnits: "All units available in the database",
        allowCustomFormulas: "Permite formule customizate",
        allowCustomPackageSize: "Permite marimi de ambalaje customizate",
        allowFormulaAutomaticNaming: "Permite denumire automata",
        automaticNaming: "Denumire automata formula",
        basePanelSize: "Set size of base panel",
        bippPanelSize: "Set size of base in product package panel",
        blendColorNameAndCode: "Blend color name and color code",
        buttonBellowMoreInfo: "Show button below formula notes",
        buttonInColorantPanel: "Show button in Colorants panel",
        colorCodePrimary: "Color code as primary",
        colorPanel: "Color palette",
        colorPreviewAsImage: "Color preview as image",
        colorPreviewResizable: "Resizable color preview",
        competitiveColorSearch: "Cautare culoare competitiva",
        customFormula: "Custom formula",
        customFormulaForMasterProduct: "Allow create custom formulas for master product",
        customFormulaForMasterProductDefault: "Checked by default",
        customFormulas: "Custom Formulas",
        customPackageSettingsUnitGrav: "Custom package settings gravimetric unit",
        customPackageSettingsUnitVol: "Custom package settings volumetric unit",
        customPackageSize: "Customizare marime ambalaj",
        customUnits: "Choose custom units",
        dropDownCalculate: "Expand the drop down menu to the height of the window",
        editColorants: "Editeaza coloranti",
        editColorantsAllowed: "Permite editare coloranti",
        fandeckPanelSize: "Set size of fandeck panel",
        favoriteFormulas: "Formule Favorite",
        formulaColorPreview: "Previzualizare culoare formula",
        formulaDataSettings: "Setare baza date formule",
        formulaPanel: "Panou cu Formule",
        formulaPanelSize: "Set size of color panel",
        formulaSettings: "Setari Formula",
        generateColorPreview: "Generate color preview",
        gravimetricOnly: "Gravimetric units only",
        hideAlternativeFormulas: "Hide alternative formulas",
        hideFormulaProperties: "Hide formula properties",
        hideHistoricalFormulas: "Hide historical formulas",
        imagesLocal: "Use only image from local database",
        imagesOnline: "Primarily, try to open online image, if it fails, open local image",
        infoPanelResizable: "Resizable more info panel",
        numberOfColorants: "Number of shown colorants",
        orderByDistance: "Order of search results by the distance",
        productDependent: "Unit depends on the selected product",
        productFilesDialog: "Show dialog to open local file or online file",
        productFilesLocal: "Use only product files from local database",
        productFilesOnline: "Primarily, try to open online product file, if it fails, open local file",
        productPanelSize: "Set size of product panel",
        searchPanelQuickSelect: "Quick select",
        setAdditionalFormulaPanel: "Setare panou aditional formule",
        setCompetitiveColorSearch: "Enable competitive color search",
        setInitialFormulaPanel: "Setari initiale panou cu formule",
        setMaxToleranceForCompetitiveColors: "Seteaza toleranta maxima pentru cautarea culorii competitive.",
        setNumberOfCompetitiveColors: "Seteaza numarul de culori competitive.",
        setSearchPanel: "Seteaza fereastra de cautare.",
        setVisibilityAndOrder: "Setare vizibilitate si comanda variatelor baze de date ale formulelor",
        setVisibleUnit: "Setare unitati vizibile",
        showColorPreview: "Afisare culoare",
        showInFormulaStatusPanel: "Show in formula status panel",
        showInMoreInfoPanel: "Show in formula notes",
        sorting: "Colorant panel sorting",
        useBase: "Use selection item for base",
        useBaseInProductPackage: "Use selection item for base in product package",
        useColorCode: "Use color code",
        useColorName: "Use color name",
        useFandeckGroups: "Use fandeck groups",
        useProduct: "Use selection item for product",
        useProductCode: "Use product code",
        useProductGroups: "Use product groups",
        volumetricOnly: "Volumetric units only"
    },
    general: {
        accepted: "Accepted",
        active: "Ultima activitate",
        actual: "Actual",
        actualLevel: "Nivel actual",
        add: "Adauga",
        addColorant: "Adauga Colorant",
        addColorantForPackage: "Add colorant for package",
        addFile: "Add file",
        all: "Toate",
        amount: "Valoare",
        applyNow: "Apply now",
        attachments: "Attachments",
        automaticCorrection: "Automatic correction",
        automatically: "Automatically",
        available: "Available",
        back: "Inapoi",
        base: "Baza",
        baseInProductPackage: "Baza in produs si ambalaj",
        batchNumber: "Batch number",
        bottom: "Jos",
        buildingSite: "Building site",
        calculate: "Calculate",
        can: "Cutie ",
        canSize: "Marime cutie",
        cancel: "Anuleaza",
        canister: "Canister",
        canisterId: "ID canistra",
        canisterIndex: "Canister Index",
        canisters: "Canistre",
        cap: "Capac",
        capacity: "Capacitate",
        channels: "Circuit",
        choose: "Alege",
        city: "Oras",
        clean: "Curata",
        clear: "Curata",
        client: "Client",
        close: "Inchide",
        closeAll: "Close all",
        collapseAll: "Collapse all",
        color: "Culoare",
        colorCode: "Codul culorii",
        colorFile: "Colorfile",
        colorName: "Nume culoare",
        colorPreview: "Previzualizare culoare",
        colorant: "Colorant",
        colorantBatchNumber: "Colorant Batch number",
        colorantPackage: "Ambalaj colorant",
        colorants: "Coloranti",
        colors: "Colors",
        company: "Companie",
        competitiveColor: "Competitive color",
        confirm: "Confirm",
        confirmDeletion: "Chiar vrei sa stergi acest articol permanent?",
        confirmHelpSettings: "Chiar vrei sa salvezi acesta forma si sa lasi campurile necompletate?",
        connect: "Conecteaza",
        continue: "Continua",
        correction: "Correction",
        country: "Country",
        created: "Creat",
        creationDateOf: "Creation date of",
        criticalLevel: "Nivel critic",
        currency: "Currency",
        currentBatchNumber: "Current batch number",
        currentUfiCode: "Current UFI code",
        custom: "Personalizat",
        customData: "Custom data",
        customFandeck: "Paletar Personalizat",
        customFormula: "Custom formula",
        customPackage: "Ambalaj personalizat",
        customPackageSettings: "Custom package settings",
        customer: "Client",
        customerVersion: "Versiune client",
        customers: "Clienti",
        database: "Baza de date",
        date: "Data",
        default: "Default",
        delete: "Sterge",
        deleteImportedData: "Delete imported records",
        delta: "Delta",
        description: "Descriere",
        disconnect: "Deconecteaza",
        discount: "Discount",
        discover: "Identifica",
        dispense: "Disperseaza",
        dispensing: "Disperseaza",
        doNotShowAgain: "Do not show this message again.",
        downloadingFile: "Fisiere descarcate",
        edit: "Editeaza",
        email: "E-mail",
        enabled: "Activeaza",
        error: "Eroare",
        expandAll: "Expand all",
        exportData: "Export data",
        exportPdf: "Export PDF",
        fan: "Paletar",
        fandeck: "Paletar",
        fandeckCode: "Fandeck code",
        fandeckName: "Nume Paletar",
        fandecks: "Fandecks",
        favorite: "Favorit",
        fileTransfer: "File transfer",
        filling: "Umplere",
        fillingDate: "Filling date",
        find: "Gaseste",
        finish: "Finish",
        finishedCorrection: "Finished correction",
        formula: "Formula",
        formulas: "Formulas",
        frontdesk: "Frontdesk",
        getQrCode: "Obtine QR Code",
        gravimetric: "Gravimetric",
        historical: "Historical",
        history: "Istoric comenzi",
        hours: "Hou.",
        id: "Id",
        images: "Images",
        in: "In",
        index: "Index",
        insertBarcode: "Insereaza cod de bare",
        install: "Instaleaza",
        installed: "Instalat",
        instructions: "Instructions",
        internalNote: "Internal note",
        interval: "Interval",
        ip: "IP adresa",
        itemNumber: "Item no.",
        itemXOfY: "Item %{x}/%{y}",
        itemsCount: "Items count",
        later: "Later",
        limit: "Limit",
        load: "Load",
        loadFormula: "Incarca formula",
        localVersion: "Versiune locala",
        machine: "MaÈinÄ",
        manualCorrection: "Manual correction",
        manually: "Manually",
        margin: "Adaos",
        markup: "Adaos",
        matching: "Matching",
        matchingFormula: "Matching formula",
        maxLevel: "Nivel Max",
        maxValue: "Max value",
        maximum: "Maximum",
        mayTakeAWhile: "This may take a while",
        measured: "Measured",
        metamarism: "Metamarism",
        minimum: "Minim",
        minutes: "Min.",
        missingItem: "Lipsa articol",
        missingRequiredItems: "Toate campurile cerute (marcate cu asterix) trebuie completate.",
        modified: "Modified",
        modifiedAutomaticCorrection: "Target color correction",
        modifiedCustomFormula: "Modified custom formula",
        modifiedStandardFormula: "Modified standard formula",
        moduleChange: "Module change",
        more: "Mai mult",
        moreInfo: "Mai multe info",
        moveDown: "Muta in Jos",
        moveUp: "Muta in sus",
        myOrders: "Comenzile mele",
        name: "Nume",
        nameTitle: "Titlu",
        new: "Nou",
        next: "Urmatorul",
        no: "Nu",
        noColorantsAvailable: "Nici un colorant disponibil",
        noFormulas: "Nici o formula inca",
        noPricesAvailable: "Nici un pret disponibil",
        nominalAmount: "Valoare nominala",
        notAvailable: "Nu e disponibil",
        note: "Nota",
        numberOfCanisters: "NumÄrul de canistre",
        numberOfItemCount: "Number of '%{item}': %{count}",
        numberOfLabels: "Numar de etichete",
        numberOfPackages: "Nuamarul de ambalaje",
        off: "Off",
        ok: "OK",
        on: "On",
        onFocus: "On focus",
        open: "Deschide",
        operator: "Operator",
        options: "Optiuni",
        order: "Order",
        other: "Altele",
        otherError: "Alta eroare",
        out: "Out",
        overwrite: "Overwrite",
        package: "Ambalaj",
        packagePreview: "Previzualizare ambalaj",
        partialUpdates: "Partial updates",
        phone: "Telefon",
        pleaseWait: "Please wait",
        previous: "Previous",
        price: "Pret",
        priceGroup: "Price group",
        print: "Printeaza",
        printTask: "Print task",
        processingStep: "Processing %{step}",
        product: "Produs",
        productCode: "Product code",
        productName: "Product name",
        products: "Produse",
        pump1: "Pompa 1",
        pump2: "Pompa 2",
        purchasePrice: "Purchase price",
        purge: "Purjeaza",
        qualityControl: "Quality control",
        quantity: "Cantitate",
        quantityQty: "QTY",
        quickTint: "Colorare Rapida",
        rccIsNotAvailable: "RCC nu e valabil",
        rccIsNotConnected: "RCC nu este conectat",
        rccNotLicensed: "RCC nu are licenta",
        reconnect: "Reconecteaza",
        refill: "Reumplere",
        refillManualLevelCorrection: "Manual correction",
        reformulation: "Reformulation",
        reloadTab: "Reload Tab",
        reset: "Reseteaza",
        restart: "Restarteaza",
        restore: "Restore",
        retint: "Retint",
        revision: "Revizie",
        safetySheet: "Safety sheet",
        save: "Salveaza",
        saveAs: "Salveaza ca",
        saveToDispensingHistory: "Salveaza in istoric",
        searchResult: "Search result",
        searching: "Searching",
        seconds: "Sec.",
        select: "Select",
        selectAll: "Selecteaza Tot",
        selectChannels: "SelectaÈi circuite",
        selectColumns: "Select columns to work with",
        selectXFirst: "Select %{item} first",
        sellPrice: "Sell price",
        settings: "Setari",
        shelf: "Raft",
        showItem: "Show %{item}",
        showOptions: "Show another options",
        size: "Size",
        skip: "Sari peste",
        smartPurge: "Smart purge",
        softwareRestartInSeconds: "%{software} will be automatically restarted in %{seconds} seconds",
        sortResults: "Sort results",
        spectro: "Spectro",
        standardFormula: "Standard formula",
        status: "Status",
        street: "Strada",
        sum: "Sum",
        summary: "Sumar",
        sync: "Sync",
        technicalSheet: "Technical sheet",
        templates: "Model",
        threshold: "Threshold",
        ticketing: "Ticketing",
        tintometricSystem: "Tintometric system",
        toDispenseOrders: "To Dispense Orders",
        top: "Sus",
        total: "Total",
        totalAmount: "Total amount",
        totalBaseAmount: "Total base amount",
        totalColorantAmount: "Total colorants amount",
        type: "Type",
        ufiCode: "UFI code",
        ufiThreshold: "UFI threshold",
        unableToSynchronize: "Unable to synchronize",
        undefined: "Undefined",
        unit: "Unit",
        units: "Unitati",
        unknown: "Unknown",
        update: "Update",
        updated: "Updatat",
        user: "Utilizator",
        value: "Value",
        vat: "TVA",
        verified: "Verified",
        version: "Versiune",
        versionId: "Versiune ID",
        versionStructure: "Versiune structura",
        volumetric: "Volumetric",
        warning: "Atentie",
        warningLevel: "Nivel avertizare",
        withoutName: "(without name)",
        workingProperly: "Working properly",
        yes: "Da",
        zoom: "Zoom"
    },
    help: {
        autotasks: {
            brushMaintenance:
                "Set this autotask to have %{name} request the action for cleaning the brush container automatically at the defined time. The dispenser operator needs to remove, clean, and then return the brush container manually.",
            capMaintenance:
                "Set this autotask to have %{name} request the action for cleaning the cap automatically at the defined time. The dispenser operator needs to clean the autocap manually after it opens.",
            cleanAll:
                "Set this autotask to have the dispenser perform the action for cleaning all channels automatically at the defined time.",
            cleanChannels:
                "Set this autotask to have the dispenser perform the action for cleaning specific channels automatically at the defined time.",
            computerReboot: "Set this autotask to have the computer rebooted automatically at the define time.",
            computerShutdown: "Set this autotask to have the computer turned off automatically at the define time.",
            dispenserCleaning:
                "Set this autotask to have %{name} request the action for cleaning the dispenser automatically at the defined time. The dispenser operator needs to clean the machine with a cloth manually.",
            humidifierWaterLevelMaintenance:
                "Set this autotask to have %{name} request the action for refilling the humidifier automatically at the defined time. The dispenser operator needs to check and refill the water in the humidifier manually.",
            purgeAll:
                "Set this autotask to have the dispenser perform the action for purging all channels automatically at the defined time.",
            purgeChannels:
                "Set this autotask to have the dispenser perform the action for purging specific channels automatically at the defined time.",
            recirculateAll:
                "Set this autotask to have the dispenser perform the action for recirculating all channels automatically at the defined time.",
            recirculateChannels:
                "Set this autotask to have the dispenser perform the action for recirculating specific channels automatically at the defined time.",
            refillAll:
                "Set this autotask to have %{name} request the action for refilling all channels automatically at the defined time. The dispenser operator needs to refill colorants into all canisters manually.",
            refillCanisters:
                "Set this autotask to have %{name} request the action for refilling specific channels automatically at the defined time. The dispenser operator needs to manually refill colorants into canisters which do not meet the refill criterion.",
            smartPurgeAll:
                "Set this autotask to have the dispenser perform the action for smart purging all channels automatically at the defined time. Purge will be carried out unless the Smart purge rules are met.",
            smartPurgeChannels:
                "Set this autotask to have the dispenser perform the action for smart purging specific channels automatically at the defined time. Purge will be carried out unless the Smart purge rules are met.",
            stirAll:
                "Set this autotask to have the dispenser perform request the action for stirring all channels automatically at the defined time.",
            stirCanisters:
                "Set this autotask to have the dispenser perform request the action for stirring specific channels automatically at the defined time.",
            switchPlateMaintenance:
                "Set this autotask to have %{name} request the action for cleaning the switch plate automatically at the defined time. The dispenser operator needs to remove, clean, and then return the switch plate manually."
        },
        colorantBatchNumber: {
            batchNumberByPercentage:
                "The Batch number which prevails is used for printing considering its actual amount in the canister. Navigate to Canister settings to define the threshold for each canister.",
            batchNumberFromLastFilling:
                "The Batch from the last refill given by the operator is used for printing regardless the refilled amount.",
            enableBatchNumber: "With this setting on, refilled colorant batches are tracked."
        },
        connection: {
            add: "Allows to add a new server manually if it could not be detected via the Discover function.",
            clientIdentifier:
                "The setting enables to identify this client if there are more clients connected to one server.",
            disconnect:
                "Information about the currently used server. The disconnect button allows to leave this server and switch to another one if available.",
            discover: "Discovers whether there are any other servers available in the network.",
            dropServers: "Deletes all previously detected servers from the list.",
            dropServersNotAvailable: "No server available",
            edit: "Allows to manually edit an already found server.",
            editDisabled: "No server selected."
        },
        continue: "Do you really want to continue?",
        driverSettings: {
            alfaRestApi: {
                host: "Tasteaza in computer numele host sau adresa IP a computerului",
                machineType: "Valabil pentru toate masinile Alfa.Windows si Linux"
            },
            corobDsProxy: {
                machineType:
                    "Disponibil pentru generatiile (D200, D600..), 4G (First One) si 5G (EvoFlx). DspProxy trebuie instalat. Numai Windows."
            },
            corobEvoDriver: {
                machineType: "Disponibil pentru generatia 5G (EvoFlx). EVOservice trebuie instalat. Windows si Linux."
            },
            corobFlex500LLD: {
                dispenserConfigurationFile: "Selecteaza fisierul de configurare a dispenserului.Pre-Setari automate",
                hldRootDir: "Selecteaza fisierul principal HLD.Pre-Setari automate.",
                machineType:
                    "Valid for Corob Flex (500, 520, 540) = former Lenteq. HLD must be installed. Windows only."
            },
            corobNextDriver: {
                machineType:
                    "Disponibil pentru generatiile (D200, D600..), 4G (First One) si 5G (EvoFlx). NextDriver trebuie instalat.Numai  Linux ."
            },
            dromontDDrv: {
                databasePath: "Catre fisierul cu baza de date pentru calibrare.Pre-Setari automate.",
                driverPath: "Catre  driver (D_DRV.exe).Pre-Setari automate.",
                machineType:
                    "Comnicare indirecta a dispenserului via set paths. Valid pentru  generatiile V1 and V2. D_SET trebuie instalat. Windows si Linux.",
                resultPath: "Catre fisierul creat ca rezultat al inchiderii opertiunii. Pre-Set automate.",
                serviceSoftwarePath: "Catre  Dromont service software (D_SET.exe). Pre-Set automate."
            },
            dromontDirect: {
                machineType:
                    "Comunicare directa dispenser. Valid pentru V1 and V2. D_SET trebuie instalat. Windows si Linux.",
                rootDir: "Selecteaza fisierul principal Dromont "
            },
            dromontMisura: {
                driverPath:
                    "Catre driver (MisuraRetail.exe) ar putea schimba baza pe versiunea  Misura Retail . Pre-Set automate.",
                extensionPath: "Catre fisierul de comunicare pentru actiunile de service.",
                formulaPath: "Catre fisierul de comunicare pentru dispersie.",
                machineType: "Valid pentru generatia V3. Dromont Misura trebuie instalat. Numai Windows."
            },
            fastAndFluidIDD: {
                machineType: "Valid pentru toate F&F machines. Numai Windows .",
                path: "Sunt suportate IDD2 (HA 450, HA 650, X-smart, etc.) - trebuie licenta, IDD3 (HP 500, etc.), IDD4 (HA 180, HA 480, HA 680, Xprotint, etc.)"
            },
            fastAndFluidUIDD: {
                host: "Type in the computer host name or computer IP address.",
                machineType: "Valid pentru toate F&F machines.Windows si Linux.",
                password: "Type in the user password.",
                port: "Select the port number.",
                user: "Type in the user name."
            },
            heroPCPDriver: {
                machineType: "Valid pentru toate Hero machines. Numai Windows ."
            },
            italtinto: {
                machineType:
                    "Valid pentru toate Italtinto machines. Wcal sau ItaltintoCal trebuie instalat. Numai Windows.",
                path: "Catre fisierul de configurare ajustat  Italtinto ."
            },
            manualAdvanced: {
                machineType: "Valid pentru toate masinile manuale, suportul pentru canistra inclus. Windows si Linux.",
                path: "Catre fisierul de configurare cu date despre dispenser si canistre."
            },
            manualSimple: {
                machineType: "Valid pentru toate masinile manuale.Windows si Linux.",
                path: "Catre fisierul de configurare cu date despre dispenser ."
            },
            none: {
                machineType: "No dispenser driver is selected."
            },
            santintColorLink3: {
                machineType: "Valid pentru toate Santint machines. Numai Windows ."
            },
            simulation: {
                machineType:
                    "Valid pentru dispenser pentru simulare daca nu exista dispenser real conectat la computer.",
                path: "Catre fisierul de simulare al configurarii care trebuie sa fie in acord baza de date inserata."
            },
            udcp: {
                machineType: "UDCP dispenser"
            }
        },
        environment: {
            activeServerPlugins: "The overview of additional software plugins.",
            allowAutoCloseTab:
                "With the setting on, each formula tab will be closed automatically after the dispensing process has been finished.",
            allowAutomaticClientStart: "Cu aceasta setare on, %{name} va porni automatdupa pornirea computerului.",
            allowAutomaticPrint:
                "Eticheta va fi printata automat.E nevoie de setari suplimentare ale imprimantei inainte de dispersare,dupa dispersare sau ambele.",
            allowBuildingSitePanel: "On Formula Panel, building site panel will be available.",
            allowCustomers: "In fereastra de formule,selectia clientilor va fi accesibila.",
            allowDispensing: "On Formula panel, Dispense button  will be activated.",
            allowFileTransfer: "With this setting on, automatic data import and export by file transfer is available.",
            allowFormulaModificationPanel: "On Formula Panel, Modification panel will be activated.",
            allowFormulaStatusPanel: "On Formula Panel, Status panel will be activated.",
            allowLight: "%{name} will be accessible..",
            allowOrdering: "In fereastra de formule,Butonul de comanda va fi activat.",
            allowPricing:
                "In fereasta Formula ,pretul poate fi folosit.Vizibilitatea pretului poate fi setat in Preturi Valabile.Preturile sunt setate in Setari preturi.",
            allowProductPreviewImage: "Imaginea produsului va fi afisata in timpul dispersiei.",
            allowQualityControl: "Quality control will be activated.",
            allowSearchCheaperColors: "On Formula Panel, the function to search for cheaper colors will be available.",
            allowSoundNotification: "Notificarea sonora la primirea comenzii este o melodie.",
            allowSpectro: "Sectiunea spectro va fi accessibila.",
            allowTabs: "With this setting on, working with multiple tabs simultaneously is available.",
            applyZoom: "Zoom mareste sau micsoreaza rezolutia.Se pot folosi keyboard shortcuts CTRL+ sau CTRL-.",
            automaticLogout: "Set after how many minutes the automatic logout should be activated.",
            availableDatabases: "Setarile permit sa schimbati bazele de date intre ele,daca sunt mai multe valabile.",
            backupLocalDB: "Exports the local databse. The exported file can be used as database backup.",
            barcodeTesting:
                "Codul de bare  care testeaza mediul verifica corectitudinea scanarii comparandu-l cu cel inserat in baza de date",
            customBanner: "Seteaza Logo-ul sau Bannner-ul in pozitia sa.",
            customCurrencyFormat:
                "Custom currency format can override default currency format based on selected language. ",
            customDateFormat: "Custom date format can override default date format based on selected language.",
            customNumberFormat: "Custom numer format can override default numer format based on selected language.",
            customTimeFormat: "Custom time format can override default time format based on selected language.",
            defaultPrinter:
                "Imprimanta selectata va fi folosita daca in fereastra Optiuni imprimanta nu se fac modificari.",
            defaultTemplate:
                "Modelul de eticheta selectat va fi folosit daca in fereastra Optiuni imprimanta nu se fac modificari.",
            deleteImportedData: "Sterge baza de date precedenta.Baza de date poate fi importata din nou dupa aceasta.",
            diskSpaceNotification: "Checks the available disk space and notifies in case of insufficient space.",
            dispensingNotes: "In fereastra de formule,notele despre dispersie vor fi accesibile.",
            downloadListEmpty: "No downloads in progress",
            enableVirtualKeyboard: "In %{name}, keyboard virtual  va fi valabil.",
            exportLocalSettings: "Exports the local settings of this computer.",
            exportStaticSql:
                "Exports the local settings of this computer. The exported file can be used to create a database with this setup.",
            exportTranslationKeys:
                "Export the newest translations and after translating, send them by email to your software supplier to have them imported.",
            favoriteButton: "Click to add the formula as favorite",
            formulaNotes: "In fereastra de formule,sectiunea note formule va fi accesibila.",
            helpSettings: "Informatiile sunt accesibie in sectiunea Ajutor  din fereatrra acces rapid.",
            importCustomData: "Importa baza de date in formatul selectat.",
            importExcelFile: "Import the excel file with data to be added to database.",
            importsLocalSettings: "Imports the local settings of this computer.",
            internalNote: "On Formula panel, internal note section will be accessible.",
            lockComputer:
                "Setarile asigura ca mediul %{name} nu poate fi lasat- el permite cele mai recente kiosk mode experience. Numai Windows.",
            maxNumberTabs: "Tab limita seteaza cate tab-uri de formule pot fi deschise simultan.",
            memoryTabs: "Allow reopening of recently opened tabs after the software starts.",
            printAfterDispensing:
                "Setarea are  nevoie de informatii despre cate copii de etichete trebuie printate dupa dispersare.",
            printAsImage:
                "Printeaza ca in imagine ajuta la rezolvarea problemei atunci cand printarea standard esuaza.A nu se folosi atunci cand printarea standard functioneaza corect.Acesta functie e compatibila numai in Linux.",
            printBeforeDispensing:
                "Setarea are  nevoie de informatii despre cate copii de etichete trebuie printate inainte de dispersare.",
            printEnabled:
                "This setting enables using printer with the software. Additional settings are in Print Settings.",
            printOnRequest: "In fereastra de formule,butonul Imprimare va fi activat.",
            printTaskVariable: "The print task is processed only if given print variable is available in print data",
            quickTintTemplate: "Urmatoarele modele de etichete vor fi folosite pentru imprimare rapida.",
            restoreLocalSettings: "Restores the local settings of this computer.",
            runLightAtStartUp: "%{light} va fi pornit in loc de %{name}.",
            screenSaverTimeout: "Set after how many minutes, the screensaver should be activated.",
            selectCustomDataFormat:
                "Selecteaza formatul bazei de date originale care se importa.Fiecare format ar trebui sa ceara diferite fisiere si setari aditionale.",
            setCustomHomeButton: "Butonul acasa in %{name} va redirectiona catre fereastra selectata.",
            setFts: "Cautarea dupa text complet permite cautarea formulei dupa text complet ( de asemenea de la mijlocul cuvantului,etc)",
            setKeyboardShortcuts: "Nu este posibil sa setezi aceleasi keyboard shortcuts pentru doua actiuni diferite.",
            setNumberOfDecimalPlaces: "Rotunjirea seteaza cate decimale au colorantii  in formula aratata.",
            setOrderSearchParameters:
                "Cautare comenzi defineste ce parametrii sunt vizibili in fereastra de acces rapid.Accesibil numai in %{name}.",
            setOverwriteLastTab:
                "When choosing a new formula via global search whereas formula tab limit is reached, the last loaded formula tab will be overwritten by the new formula selection.",
            setSearchPanel: "Seteaza vizibilitatea si ordoneaza parametrii  folositi pentru cautarea unei noi formule",
            setVisibilityAndOrder:
                "Instrumentele de navigare vor fi vizibile in fereastra de acces rapid.Pozitia cea mai de sus defineste pozitia cea mai din stanga din fereastra.Se pot selecta maxim 6 elemente.",
            setYourLanguage: "Schimbarea limbii necesita restartarea software.",
            settingsSearch: "Look up various settings if you are unsure where to find them.",
            showNewOrderNotifications:
                "Notificarea comenzii este o fereastra pop-up care anunta ca s-a primit o comanda.",
            sorting: "Colorarea rapida poate avea canistrele ordonate dupa numele colorantilor sau ID colorant",
            turnOnKioskMode: "Modul Kiosk este in task bar ascunse.",
            windowClosingRules:
                "Setarea decide daca fereastra dispersare rapida se inchide inainte sau dupa inceperea procesului de dispersare."
        },
        formulaSettings: {
            additionalFormulaTab: "The setting decides which panel will be shown when opening a new formula tab.",
            allowCustomFormulas: "Crearea si customizarea formulei va fi activata.",
            allowCustomPackageSize: "In fereastra de formule,customizarea marimii ambalajului va fi activata.",
            allowEditingColorants:
                "In fereastra de formule.butonul de Editare al colorantului va fi activat (vizibila dupa ce s-a selectat culoarea)",
            alternativeFormulasPosition: "Defines how to access alternative formulas.",
            basePanelSize: "Set size of base on Formula panel",
            bippPanelSize: "Set size of base in product package on Formula panel",
            blendColorNameAndCode:
                "The setting joins together the search fields for Color name and code to create one search field only.",
            color: "In fereastra de formule,previzualizarea culorii va fi singura informatie disponibila.",
            colorCodePrimary: "Color code will be displayed first in the search field.",
            colorPreviewAsImage: "On Formula panel, the color preview will be represented by image.",
            colorPreviewResizable: "Allows to resize color preview panel.",
            colorantPanelLimit:
                "The settings sets the number of colorants that will be always visible before it hides under scroll bar.",
            colorantPanelOrderBy: "Formula panel can have the colorants ordered according to the names or by amounts.",
            customCanOption: "Choose which measurement units can be used for custom package size on Formula panel.",
            customCanSettingsUnit:
                "Choose which measurement unit can be used as default for custom package settings on Formula panel.",
            customFormulaForMasterProduct:
                "Defines whether the option âFormula for master productâ is displayed when saving custom formula",
            customFormulaForMasterProductDefault:
                "Defines whether the option âFormula for master productâ is checked by default",
            deleteConfirmation: "Activarea acestei setari va fi notificata in pop-up,confirmand stergerea unei note.",
            dropDownCalculate:
                "The drop-down menu to select the formula you are looking for will extend to the bottom of the window.",
            fandeckGroups: "The setting enables hierarchy with fandeck groups if available in the database.",
            fandeckPanelSize: "Set size of fandeck on Formula panel",
            favoriteFormulasInitial: "Cand porneste %{name}, fereastra Favorite va aparea.",
            formulaAutomaticNaming:
                "O formula schimbata va fi denumita automat pe baza modificarilor facute la coloranti.",
            formulaPanel: "Cand se deschide un nou tab,fereastra de formule va aparea.",
            formulaPanelInitial: "Cand se porneste %{name}, fereastra de formule va aparea.",
            formulaPanelSize: "Set size of color on Formula panel",
            formulaPropertiesPosition: "Defines how to access formula properties.",
            generateColorPreview:
                "With this setting on, the color preview will be generated automatically. The resulting preview is not accurate.",
            historicalFormulasPosition: "Defines how to access historical formulas.",
            image: "In fereastra de formule,imaginea produsului va fi vizibila langa culoarea previzualizata cu posibilitatea de deschiderea a ferestrei cu mai multe info.",
            images: "The setting defines the source of image files.",
            infoPanelResizable: "Allows to resize more info panel.",
            initialFormulaTab: "The setting decides which panel will be shown after %{0} starts.",
            moreInfo:
                "In fereastra de formule,fereastra de informatii va fi vizibila langa culoarea previzualizata si produsul previzualizat.",
            orderByDistance: "With this setting on, the result of color search is ordered by special distance metric.",
            productCode:
                "The setting enables to use product codes along with product names if available in the database.",
            productFiles: "The setting defines the source of product files which are available on Formula panel.",
            productGroups: "The setting enables hierarchy with product groups if available in the database.",
            productPanelSize: "Set size of product on Formula panel",
            searchNewFormula:
                "Cand se deschide un nou tab,fereastra de Cautare formula va aparea (contine informatii despre ultima formula dispersata si formule favorite)",
            searchNewFormulaInitial:
                "Cand se porneste %{name}, Cautare formula va aparea(contine informatii despre ultima formula dispersata si formule favorite).",
            searchPanelFormulaItems: "At least one of the formula items must be selected.",
            searchPanelProductItems: "Only one of the product items can be selected.",
            searchPanelQuickSelect:
                "No need to press the load formula button. You will be redirected directly to main formula tab just after formula selection.",
            setCompetitiveColorSearch:
                "With this setting on, the feature of competitive color search in Color Palette and Formula panel (only for not available formulas) is available.",
            setFormulaInfoInPreview:
                "On Formula panel, the selected data type will be always visible in the color preview.",
            setFormulaPreview:
                "The setting changes the position and display of color preview, package image and info data about the color.",
            setFormulaRGBPreviewVisibleInformation:
                "In fereastra de formule,datele selectate vor fi vizibile intotdeauna in previzualizare culoare.",
            setFormulaUnit:
                "In fereastra de formule,setarile decid care colorant va fi pus primul dupa selectarea culorii.Se aplica si pentru Dispersarea rapida.",
            setFormulaVisibilityAndOrder:
                "In fereastra de formule,datele selectate vor fi vizibile in sectiunea Mai multe info.(valabil numai daca setarea previzualizarea formulei,in setari Formula , este Imagine sau Mai multe info",
            setMaxToleranceForCompetitiveColors:
                "Set the maximal Delta E (CIA 2000) tolerance for competitive color search.",
            setNumberOfCompetitiveColors:
                "Define how many competitive master colors should be offered after search. The defined number does not correspond to the number of results.",
            setVisibleUnit:
                "In fereastra de formule,setarile decid care colorant este vizibil dupa selectarea culorii.Se aplica si pentru Dispersarea rapida.",
            showColorPreview:
                "In fereastra de formule,arata o mica previzualizarea a culorii langa numele culorii cand cauti o noua formula.",
            showSiblingProducts:
                "Defines whether the option âShow sibling productsâ is displayed when saving custom formula",
            useColorCode: "On Formula panel, shows the information about color code."
        },
        formulaValidation: {
            batchNumberInvalid: "Canister (%{colorants}) is filled with a defective batch of colorant.",
            batchNumberWarning: "Colorant (%{colorants}) with this batch number may be damaged.",
            bellowBaseLimit: "Sum of colorant amounts is below base limit.",
            checkColorantBaseRules: "The setting checks if used colorants and base can be used in this combination.",
            checkMinDosableAmount:
                "The minimal tintable amount is the smallest colorant amount which can be dispensed as recommended by the laboratory.",
            checkOverfill:
                "The setting checks if there is enough space in the can for the colorants immediately after the amounts are set.",
            checkTotalCntAmounts:
                "The setting checks if the limits for the minimal and maximal colorant amounts in product base package have been exceeted. These limits are defined in the database.",
            colorantBaseRules: "Colorant is not valid for selected base.",
            colorantMinAmount: "Colorant amount is below the minimal tintable amount.",
            dispensingWithErrorsEnabled:
                "If allowed, a warning message will appear in case of validation violations, but it will be possible to proceed to dispensing nonetheless.",
            invalidBatchNumber: "Colorant has invalid or defective batch number",
            overBaseLimit: "Sum of colorant amounts is over maximal tintable amount.",
            overfill: "Overfill has been detected.",
            unifyColorantBatchForMultipleCans:
                "If allowed, an info refill to max modal will appear when amount of colorant is bigger than maximum of canister and canister is not filled on maximum level.",
            warningConfirmBtn: "I know the risks, continue"
        },
        help: "Ajutor",
        helpLink: "Ajutor",
        helper: {
            automaticallyCheckForUpdates:
                "Se va verifica automat daca exista un update disponibil pentru %{name} sau baza de date intr-un anumit interval de timp.",
            automaticallyDownloadUpdates:
                "Daca exista un update diponibil,se va descarca automat fara a fi nevoie de confirmare.",
            automaticallyInstallNewDatabases:
                "Daca este trimis DB pana acum absent,se va instala automat fara a fi nevoie de confirmare",
            automaticallyInstallUpdates:
                "Daca un update a fost descarcat,el se va instala automat fara a fi nevoie de confirmare",
            canBrowseChangeLog: "Cand se face update de software, schimbarea  %{name} oficiala va fi vizualizata.",
            forceInstall: "The update will be installed by force.",
            installDuringNight: "Update-ul se va instala pe timpul noptii daca computerul este in functiune."
        },
        licensing: {
            collect:
                "The logfiles will be downloaded to the selected location. The logfiles are required by the software supplied for bug analysis.",
            company: "The company which supplied the license.",
            computerID: "License identification to help the software supplier in case of required assistance.",
            email: "The email address of the license holder.",
            licenseUuid: "License identification to help the software supplier in case of required assistance.",
            name: "The name of the license holder.",
            openBugreport:
                "Please let us know if there is a bug in the software and send us a report with the bug description.",
            posInfoContactperson: "POS information about the owner to be printed on the label.",
            posInfoMachineInformation:
                "POS information about the dispenser to be printed on the label or recognized in the network.",
            posInfoPos: "POS information about the location to be printed on the label.",
            reactivation: "Reactivation or change of the current license.",
            refresh: "Downloads the newest license information.",
            refreshUnavailable: "License refresh unavailable because you are offline.",
            registrationContactperson: "Registration information to identify the owner of the license.",
            registrationMachineInformation: "Registration information to identify the dispenser of the license.",
            registrationPos: "Registration information to identify the location of the license.",
            versionScope: "The software expiration limits.",
            versionType: "The software product type."
        },
        machineIsBusy: "Erorile nu pot fi resetate cand masina este in functiune",
        machineSettings: {
            allowManualColorantAddition:
                "Daca cantitatea necesara de colorant este mai mare decat se poate dispersa ,setarile permit adaugarea de colorant dupa dispersare. ",
            autotasks:
                "Autotask sunt proceduri de mentenanta ale masinii si computerului care se pot seta la o anumita ora sau interval de timp.",
            barcodeRefillValidation: "The setting turns on barcode validation on refill.",
            barcodeRefillValidationBaseAndColorant:
                "Barcode check is performed on canister and colorant package refilling.",
            barcodeRefillValidationColorant: "Barcode check is performed on colorant package refilling.",
            canisterBarcode:
                "The barcode is assigned to the canister in which the colorant is available. The barcode is necessary to ensure correct colorant refilling.",
            checkCanBeforeDispense: "The setting is only valid for Fast & Fluid simulation.",
            checkOverfill:
                "Setarile verifica daca este sufient volum in cutie pentru colorantul din formula ,inaintea inceperii dispersiei.",
            currentlySelectedMachine: "Provides information about the currently selected machine.",
            dispenseInvalidColorants:
                "Setarile permit sa dispersati colorantii care nu sunt definiti in configurarea masinii prin afisarea aditie manuala de colorant",
            dispenserConfigurationBackup: "Download and save the current machine configuration to maintain a backup.",
            dispensingLogic:
                "Dispensing logic types can ensure different behaviour for each canisters when there is more colorant to be dispensed than allowed or desired. Additional behavior is set in Dispensing Settings.",
            enableTmc: "Setarile permit trimiterea datelor catre TMC.",
            enableUserIdentification: "User has to log in before dispensing is allowed.",
            machineUnit: "Unitate masina defineste unitatea de masura a colorantului din canistre.",
            minDispensedAmount:
                "Cantitatea minima seteaza cat colorant trebuie dispersat astfel incat purjarea sa fie totala.",
            minimalDispenseAmount:
                "Cantitatea minima de dispersat este cea mai mica cantitate de colorant recomandata care poate fi dispersata.Daca nu se repecta,va aparea un mesaj(dispersarea e inca posibila).",
            missingAutotaskCanisters: "Trebuie seelectata cel putin 1 canistra",
            missingAutotaskChannels: "Trebuie selectat cel putin un circuit",
            missingAutotaskChannelsValue: "Volumul tuturor circuitelor selectate trebuie completat",
            missingAutotaskCleanTime: "Timpul de curatare trebuie completat",
            missingAutotaskName: "Numele autotask-ului trebuie completat",
            missingAutotaskRecirculation: "Timpul si viteza de recirculare trebuie completat",
            missingAutotaskStirring: "Timpul si viteza de amestecare trebuie completat",
            missingAutotaskVolume: "Volumul de purjare trebuie completat",
            placeCanSensor:
                "Setarea activeaza senzorul care detecteaza asezarea cutiei -dispersarea nu va incepe daca cutia nu este asezata corect.",
            placeCanSensorDelay:
                "Setari recomandate pentru senzorul care detecteaza asezarea cutiei.Acestea asigura ca dispersia incepe numai dupa o anumita perioada de timp necesara asezarii cutiei in pozitie corecta.",
            purgeVolume: "Volumul de purjare seteaza cat colorant este purjat cand se actioneaza smart purge.",
            rccUrl: "Redlike Control Center (RCC) is responsible for the communication with the dispenser.",
            refillThreshold:
                "If the amount of colorant in the canister with the given UFI or Batch number drops below this limit, such UFI or Batch number will be discarded.",
            refillThresholdBatch:
                "If the amount of colorant in the canister with the given Batch number drops below this limit, such Batch number will be discarded.",
            refillThresholdUfi:
                "If the amount of colorant in the canister with the given UFI drops below this limit, such UFI will be discarded.",
            removeCanSensor:
                "Setarea activeaza senzorul de retragere a cutiei-dispersarea nu este considerata incheiata pana cand cutia nu este retrasa din raftul masinii.",
            removeCanSensorDelay:
                "Setari recomandate legate de senzorul de retragere a cutiei.Asigura ca dispersarea a fost incheiata numai dupa un anumit interval de timp in care cutia a fost retrasa din raftul masinii.",
            skipPlaceCanDialog:
                "Cu aceste setari activate,dispenserul nu va astepta cand se aseza cutia pana cand butonul OK este selectat,dar va incepe sa disperseze automat.",
            skipRemoveCanDialog:
                "Cu aceste setari activate,dispenserul nu va astepta cand se retrage cutia pana cand butonul OK este selectat,dar va considera dispersarea ca fiind incheiata automat.",
            smartPurgeType:
                "Tipul de purjare poate fi fie doar prin dispersare,fie prin dispersare plus alte purjari la cerere daca smart purge este cerut.",
            splitFormula:
                "Daca cantitatea necesara de colorant este mai mare decat se poate dispersa ,setarile permit dispersarea partiala de colorant,reumplerea canistrei si apoi continuarea si finalizarea dispersarii.",
            tintometricSystem:
                "Tintometric system (set of available colorants) defines what colorants and formulas will be available in the application and application settings.",
            validateBarcodeBaseCan:
                "Cutia produsului poate fi validata prin codul de bare inainte ca dispersarea sa inceapa.Setarea asigura ca baza folosita este cea corecta.",
            validateColorantsDuringInit:
                "The machine configuration will be compared to the database each time when RCC is restarted. In case of mismatches, a notification occurs."
        },
        matchingSettings: {
            matchingInformation: "On matching result panel, %{item} will be available.",
            matchingOptionsColorants: "On matching options panel, colorants panel will be available.",
            matchingOptionsColorfile: "On matching options panel, colorfile selectbox will be available.",
            matchingOptionsSortResults: "On matching options panel, sort results selectbox will be available.",
            matchingRowCount: "Defines how many results should be offered after matching."
        },
        navigation: {
            barcodeScan: "Opens a window with the possibility to enter the barcode manually.",
            canisterBarcodes:
                "Se deschide fereastra unde vezi codul de bare al canistrei si posibilitatea de setarea a cod de bare canistra",
            canisterLevel:
                "Se deschide  fereastra unde vezi nivelul canistrei si posibilitatea de setarea a nivelului canistrei",
            canisters:
                "Se deschide  tab-ul unde vezi nivelul canistrei si posibilitatea de setarea a nivelului canistrei",
            clean: "Open a window with the possibility to clean machine channels",
            colorPanel:
                "Se deschide  tab-ul unde vezi posibilitatea de cautare a unei noi formule  in  paletarul electronic",
            colorSearchTab: "Opens a panel with possibility to search all colors in all fandecks.",
            colorantRefillHistory: "Se deschide  fereastra unde vezi canistrele care s-au reumplut",
            customFormula: "Se deschide  tab-ul unde poti crea o noua formula customizata",
            customers: "Se deschide  tab-ul unde vezi clientii si posibilitatea sa-i adaugi/editezi/stergi",
            dispensingHistory: "Se deschide  tab-ul unde vezi ce s-a dispersat",
            favorites: "Se deschide  tab-ul unde vezi posibilitatea sa selectezi o formula preferata",
            help: "Se deschide  fereastra cu informatia despre serviciul - client daca este data de furnizor",
            hideItems: "Opens a window with the possibility to mark products and fandecks as hidden.",
            historyOfOrders: "Valabil exclusiv pentru %{name} , se dechide o fereastra unde vezi comenzile dispersate.",
            machineReset: "Incepe resetarea dispenserului",
            matching: "Opens a panel with the possibility to match new color with a spectro.",
            myOrders: "Comenzile care au fost trimise de la acest computer.",
            purge: "Se deschide fereastra cu posibilitatea de a seta purjarea canistrei",
            quickTint: "Se deschide fereastra cu posibilitatea de a face dispersare manuala",
            searchFormula: "Se deschide  tab-ul cu posibilitatea sa cauti o formula noua",
            spectro: "Se deschide  tab-ul cu posibilitatea sa masori cu spectro",
            stir: "Se deschide fereastra cu posibilitatea sa setezi amestecarea canistrei",
            ticketing: "Opens a ticketing system panel.",
            toDispense: "Comenzile care au fost primite pe acest computer."
        },
        noHelpForLicense: "Nu exista suport pentru licenta dvs.Cereti furnizorului sa il adauge.",
        posInfo: {
            sync: "Se sincronizeaza datele cu sectiunea Inregistrare"
        },
        poweredByDeso: "Powered by %{name}",
        priceSettings: {
            VatPrice: "TVA colorant in %",
            VatPriceProduct: "The generic product VAT will be the same for every colorant. Set in %.",
            basePurchase: "Pret de achizitie baza de colorare (numai baza)",
            basePurchasePriceProduct: "Purchase price for the package of the given base. Set in selected currency.",
            baseSell: "Pret de vanzare baza de colorare (inclusiv margini/adaos ale bazei de colorare)",
            baseSellFull: "Sell full price for base.",
            cntName: "Defines which colorant the price is related to.",
            cntPurchase: "Pret achizitie coloranti(numai coloranti)",
            cntPurchaseByName: "Pret achizitie coloranti calculat individual pentru fiecare (numai coloranti)",
            cntPurchasePricePerLiter: "Pret de cost coloranti pe litru (fara margini sau adaos)",
            cntSell: "Pret vanzarea numai pentru coloranti(inclusiv margini/adaos)",
            cntSellByName:
                "Pret vanzare pentru toti colorantii folositi in produs calculat individual pentru fiecare (inclusiv margini/adaos )",
            cntSellFull: "Sell full price for colorants.",
            cntSellFullByName: "Sell full price for colorants by name.",
            cntSellPricePerLiter:
                "The sell price of the colorant per liter (incl. colorant exclusively). Set in the selected currency.",
            cntVat: "Colorant VAT value set in %.",
            colorants:
                "Pret generic coloranti va fi acelasi pentru fiecare dintre ei.Aceasta functie este folosita in special pentru setarea TVA.",
            colorantsPosCoeficient: "The generic colorant coeficient for POS.",
            colorantsSellPrice:
                "The generic colorant prices will be the same for every colorant. Sell price is recommended to by modified by discount. Set in selected currency.",
            currencyCodeNew: "Codul valutei trebuie sa fie compus din trei litere,de exemplu EUR,RON",
            currencyNameNew: "Numele valutei,de exemplu EURO,LEI",
            currencyRateNew:
                "Rata de schimb valutar intre principalele valute,de exemplu 4.77 RON pentru 1 â¬.Rata de schimb trebuie updatata permanent.",
            currencyRoundingNew:
                "Rotunjirea seteaza cea mai mica valoare posibila a valutei,de exemplu pentru Euro este 0.01 pentru ca cea mai mica valoare este de 1 cent.",
            currencySymbolNew: "Simbolul oficial al valutei,de exemplu â¬ pentru Euro.",
            defaultPrice: "Pretul colorantului setat in baza de date selectata (fara TVA)",
            defaultPriceGroup:
                "Pretul colorantului pentru grupul de preturi setat in baza de date selectata (fara TVA)",
            defaultVatPrice: "TVA colrant setat in baza de date selectata.",
            discountHeader: "Discount substracts the the defined value from the purchase colorant price. Set in %.",
            discountHeaderProduct:
                "Discount substracts the the defined value from the product colorant price. Set in %.",
            export: "Export a file with the currently inserted prices. It can be imported again after having modified the prices.",
            import: "Import a correctly formated (exported) file to insert or modify the prices.",
            localPrices:
                "Local prices change suggested prices from the main database and are present solely locally on this particular computer.",
            margin: "Choose which price calculation should be used for the definition of the final available price. Margin and markup add up to whereas discount substracts from the given sell price.",
            marginAll: "Valoare margini/adaos pentru multiple ambalaje (inclusiv margini/adaos)",
            marginHeader: "Margin adds the defined value up to the purchase colorant price. Set in %.",
            marginHeaderProduct: "Margin adds the defined value up to the purchase product price. Set in %.",
            marginPerPkg: "Valoare margini/adaos pentru un ambalaj (inclusiv margini/adaos)",
            markupHeader: "Markup adds the defined value up to the purchase colorant price. Set in %.",
            markupHeaderProduct: "Markup adds the defined value up to the purchase product price. Set in %.",
            packagePricing: "Costuri suplimentare setate individual pentru fiecare marime a ambalajului.",
            packageSurcharge: "Pret generic ambalaj va fi acelasi pentru fiecare cost suplimentar.",
            priceDefinition: "The setting defines which price types are used when calculating final prices.",
            priceGroupNumber:
                "The setting defines how many price groups will be used. The range for individual price groups can be set in Default Values.",
            priceGroupPricePerLiter: "Pret colorant folosit in calculul Pretul Grupei de preturi",
            priceGroups:
                "Grupurile de preÈ afiÈeazÄ numÄrul grupului de preÈ relevant (limitele sunt stabilite Ã®n baza de date sau Ã®n preÈuri generice)",
            priceGroupsEnabled:
                "The setting allows you to work with price groups. Define the range in Default Values and individual prices in Colorant Pricing.",
            priceGroupsGeneric:
                "Grupurile de preÈuri reprezintÄ intervalele de preÈ ale vopselei finale pe baza preÈurilor de coloranÈi din formulÄ.",
            productBasePackageSellPrice: "Sell price for the package of the given base. Set in selected currency.",
            productBaseSellPrice:
                "Sell price for base calculated per liter (incl. base exclusively). Set in the selected currency.",
            productBaseVat: "Product base VAT value for the given package set in %.",
            productName: "Defines which product base the price is related to.",
            productPosCoeficient: "The generic product coeficient for POS.",
            productPricing:
                "PreÈul de achiziÈie pentru toate ambalajele este utilizat cand sedisperseaza in ambalaje customizaet.",
            productSize: "Defines which package of the given product base the price is related to.",
            productVat: "Product base VAT value set in %.",
            products:
                "PreÈurile generice ale produsului vor fi aceleaÈi pentru fiecare produs. AceastÄ funcÈie este utilÄ Ã®n special pentru stabilirea TVA.",
            productsSellPrice:
                "The generic product prices will be the same for every colorant. Sell price is recommended to by modified by discount. Set in selected currency.",
            sellPriceAll:
                "PreÈul de vÃ¢nzare al mai multor ambalaje (inclusiv bazÄ, coloranÈi, costuri suplimentare Èi marjÄ / adaos).",
            sellPricePerKg:
                "PreÈul de vÃ¢nzare al produsului pe kilogram (inclusiv bazÄ, coloranÈi, costuri suplimentare Èi marjÄ / adaos).",
            sellPricePerL:
                "PreÈul de vÃ¢nzare al produsului pe litru (inclusiv bazÄ, coloranÈi, costuri suplimentare Èi marjÄ / adaos).",
            sellPricePerPkg:
                "PreÈul de vÃ¢nzare al unui ambalaj (inclusiv bazÄ, coloranÈi, costuri suplimentare Èi marjÄ / adaos).",
            setPriceTypesVisibilityAndOrder:
                "In fereastra Formula, preÈurile selectate vor fi vizibile Ã®n secÈiunea preÈuri. PoziÈia cea mai Ã®naltÄ aici defineÈte cea mai din stÃ¢nga poziÈie din secÈiune.",
            surchargeAll: "PreÈul unei taxe suplimentare pentru mai multe ambalaj (inclusiv costuri suplimentare).",
            surchargePerPkg: "PreÈul unei taxe suplimentare pentru un ambalaj (inclusiv costuri suplimentare).",
            tintPurchaseAll:
                "PreÈul de achiziÈie pentru Ã®ntregul proces de colorare a mai multor ambalaje (inclusiv coloranÈi Èi costuri suplimentare).",
            tintPurchasePerPkg:
                "PreÈul de achiziÈie pentru Ã®ntregul proces de colorare a unui ambalaj (inclusiv coloranÈi Èi costuri suplimentare).",
            tintSellFullAll: "Tint sell full price for all packages.",
            tintlSellFullAllPerPackage: "Tint sell full price per package.",
            totalPurchaseAll:
                "PreÈul total de achiziÈie al produsului pentru mai multe ambalaje (inclusiv bazÄ Èi coloranÈi).",
            totalPurchasePerKg: "PreÈul total de achiziÈie al produsului pe kilogram (inclusiv baza Èi coloranÈii).",
            totalPurchasePerL: "PreÈul total de achiziÈie al produsului pe litru (inclusiv baza Èi coloranÈii).",
            totalPurchasePerPkg:
                "PreÈul total de achiziÈie al produsului pentru un pachet (inclusiv baza Èi coloranÈii).",
            totalSellFullAll: "Total sell full price for all packages.",
            totalSellFullPerKg: "Total sell full price per kilogram.",
            totalSellFullPerLiter: "Total sell full price per liter.",
            totalSellFullPerPackage: "Total sell full price per package.",
            withAndWithoutVat: "In tab-ul Formula,pretul se va vedea simultan,cu si fara TVA",
            withVat: "In tab-ul Formula,pretul se va vedea numai cu TVA inclus",
            withoutVat: "In tab-ul Formula,pretul se va vedea numai fara TVA"
        },
        qualityControlSettings: {
            colorDifference: "Color difference model for quality control.",
            deltaA: "Defines tolerance limit for delta A in quality control.",
            deltaB: "Defines tolerance limit for delta B in quality control.",
            deltaE: "Defines tolerance limit for delta E in quality control.",
            deltaL: "Defines tolerance limit for delta L in quality control.",
            deltaMetamerism: "Defines tolerance limit for metamerism delta in quality control."
        },
        registration: {
            sync: "Se sincronizeaza datele cu sectiunea POS info"
        },
        searchingPleaseWait: "Please wait, the best match is being searched for",
        setupSteps: {
            customData: "Custom Data",
            machineType: "Machine Type",
            userPreferences: "User Preferences"
        },
        spectroSettings: {
            ColorixNanoUseProfiledValues:
                "When using profiled values, the measured results are recalculated to remove the filter effect. Allow this option for universal spectro measuring.",
            XRiteModelRM400: "No drivers required.",
            datacolorDiagnosticTile: "Datacolor use diagnostic tile",
            datacolorSilent: "Datacolor silent",
            measureModes: "Select supported gloss levels.",
            model: "Model",
            simulationPath: "Path to the simulation file. Default preset.",
            spectroType: "Official spectro driver has to be installed. Windows only.",
            spectroTypeCom:
                "Official spectro driver has to be installed. Beware of the used COM Port. Windows as well as Linux.",
            spectroTypeDataColorReader:
                "The computer has to have Bluetooth connection. The spectro has to be paired with the computer. Windows 10 with 2018 automn update required.",
            spectroTypeMinolta2XXXd:
                "Official spectro driver has to be installed. Beware of the used COM Port. Windows as well as Linux.",
            spectroTypeNotSelected: "Select your spectro model.",
            spectroTypeRM400: "No drivers required.",
            spectroTypeSimulation: "Lab values required to obtain simulation results. Windows as well as Linux.",
            spectroTypeXRite: "Windows only."
        },
        ufiCode: {
            baseUfiCodeValidation: "Base can UFI code has to be validated via barcode before dispensing is allowed.",
            enableUfiCodes:
                "UFI codes are used in EU and provide information about how hazardous a product is to environment.",
            invalidUfi: "Invalid UFI code",
            printUfiCode:
                "If a colorant in a formula exceeds the given limit, its UFI code will be printed on the print label.",
            printUfiCodePercentage:
                "If a colorant in a formula exceeds the given limit, its UFI code will be printed on the print label along with its percentage representation.",
            ufiCodesByPercentage:
                "The UFI code which prevails is used for printing considering its actual amount in the canister. Navigate to Canister settings to define the threshold for each canister.",
            ufiCodesFromDatabase:
                "The UFI code from the main database given by the database administrator is used for printing.",
            ufiCodesFromLastFilling:
                "The UFI code from the last refill given by the operator is used for printing regardless the refilled amount."
        },
        userManagement: {
            add: "The setting adds a new user who can log in into the software. The user can have a barcode assigned and can be set to log in automatically after the software is started.",
            assignedGroups:
                "This defines what user groups the user belongs to. Various user groups distribute various privileges.",
            availableGroups:
                "This defines what user groups there are available for the user. Various user groups distribute various privileges.",
            loggedUserDelete: "Currently logged in user cannot be deleted."
        },
        visit: "Sau vizitaÈi",
        visitNoLicense: "Pentru mai multe informatii va rugam vizitati"
    },
    helpSettings: {
        customHelpLink: "Linkul Centrului de ajutor personalizat",
        helpSettings: "SetÄri de ajutor",
        message: "Mesaj"
    },
    helper: {
        automaticallyCheckForUpdates: "VerificaÈi automat actualizÄrile",
        automaticallyDownloadUpdates: "DescÄrcaÈi actualizÄrile automat",
        automaticallyInstallNewDatabases: "InstalaÈi automat DB-uri noi",
        automaticallyInstallUpdates: "InstalaÈi automat actualizÄri",
        bugReport: "Raport de erori",
        canBrowseChangeLog: "Show online %{name} changelog.",
        collect: "ColectaÈi ",
        collectLogFiles: "ColectaÈi fiÈiere jurnal",
        component: "Componenta",
        content: "Continut",
        contentSize: "Marime continut",
        download: "Descarca",
        downloadLogFiles: "DescÄrcaÈi fiÈierele jurnal",
        downloadingData: "DescÄrcaÈi date",
        everyHours: "La fiecare %{interval} ore",
        forceInstall: "Force to update",
        installDuringNight: "During night (%{start} - %{end}) every %{interval} hour",
        newVersion: "Versiune noua",
        notConnected: "Ajutorul  nu este conectat",
        openBugReport: "Deschide raportul de erori",
        packageSize: "Marime ambalaj",
        pleaseWait: "VÄ rugÄm sÄ aÈteptaÈi, acest lucru poate dura ceva timp.",
        send: "Trimite",
        sendBugReportToCustomerService: "TrimiteÈi raportul de eroare la serviciul clienÈi",
        sendingReport: "Se trimite",
        subject: "Subiect"
    },
    helperDialog: {
        1: "PuteÈi verifica actualizÄrile de software sau de bazÄ de date.",
        2: "ContinuaÈi cu descÄrcarea pachetelor de actualizare?",
        3: "ContinuaÈi cu instalarea pachetelor de actualizare descÄrcate?",
        10: "Verificam actualizÄrile software Èi ale bazei de date, vÄ rugÄm sÄ aÈteptaÈi ...",
        11: "ExistÄ o actualizare disponibilÄ pentru computer. Vrei sÄ o descarci?",
        12: "Nu existÄ actualizÄri disponibile pentru computer.",
        14: "There was an error during checking for updates. %{0}",
        15: "Sincronizarea bazelor de date de zonÄ, vÄ rugÄm sÄ aÈteptaÈi ...",
        20: "Se descarca pachetul de actualizare, vÄ rugÄm sÄ aÈteptaÈi ...",
        21: "Pachetul de actualizare descÄrcat este acum Ã®n curs de verificare, vÄ rugÄm sÄ aÈteptaÈi ...",
        22: "DescÄrcarea pachetului de actualizare nu a reuÈit. DoriÈi sÄ Ã®ncercaÈi din nou?",
        23: "DescÄrcarea pachetului de actualizare nu a reuÈit (fiÈierul este defectuos), doriÈi sÄ Ã®ncercaÈi din nou?",
        24: "ContinuaÈi cu instalarea actualizÄrii?",
        25: "Instalarea actualizÄrii automate va Ã®ncepe Ã®n %{0}",
        26: "ExistÄ o actualizare disponibilÄ pentru computer. Vrei sÄ o descarci?",
        27: "ContinuaÈi cu instalarea actualizÄrii?",
        40: "Oprirea aplicaÈiilor Èi a serviciilor, vÄ rugÄm sÄ aÈteptaÈi ...",
        41: "Copierea fiÈierelor noi, vÄ rugÄm sÄ aÈteptaÈi ...",
        42: "Pornirea aplicaÈiilor Èi a serviciilor, vÄ rugÄm sÄ aÈteptaÈi ...",
        43: "Finalizarea actualizÄrii software, vÄ rugÄm sÄ aÈteptaÈi ...",
        44: "Software-ul dvs. a fost actualizat cu succes.",
        45: "DoriÈi sÄ Ã®ncercaÈi din nou instalarea? DacÄ decideÈi sÄ Ã®ncercaÈi din nou, asiguraÈi-vÄ cÄ componentele software nu sunt utilizate Ã®n prezent.",
        46: "Rebootarea PC-ului este necesarÄ pentru a afecta modificÄrile, repornirea se va face Ã®n %{0}",
        999: "A apÄrut o eroare internÄ: %{0}",
        automaticInstallation: "Instalare automatÄ de actualizare",
        btnAbort: "AbandonaÈi",
        btnCancel: "Anulare",
        btnCheckUpdate: "VerificÄ pentru actualizÄri",
        btnContinue: "Continua",
        btnDownloadUpdate: "DescÄrcaÈi actualizarea",
        btnInstallUpdate: "InstalaÈi actualizarea",
        btnOk: "O.K",
        btnRetry: "ReÃ®ncercaÈi",
        btnSkip: "Ocolire",
        checkingForUpdates: "Verificarea actualizÄrilor",
        downloadingFailed: "DescÄrcarea a eÈuat",
        downloadingPackage: "DescÄrcarea pachetului de actualizare, vÄ rugÄm sÄ aÈteptaÈi",
        finishingUpdate: "Actualizarea de finalizare",
        installingUpdate: "Instalarea actualizÄrii",
        internalError: "Eroare internÄ",
        rebootRequired: "Reboot este necesar",
        startingComponents: "Pornirea componentelor software",
        stoppingComponents: "Oprirea componentelor software",
        synchronizingDatabases: "Sincronizarea bazelor de date de zonÄ",
        updateAvailable: "ActualizaÈi disponibile, selectaÈi componentele care vor fi actualizate",
        updateDownloaded: "Actualizarea a fost descÄrcatÄ",
        updateFailed: "Procesul de actualizare nu a reuÈit",
        updateInstalled: "Actualizarea a fost instalatÄ",
        verificationFailed: "Verificarea pachetului de actualizare nu a reuÈit",
        verifyingPackage: "Verificarea pachetului descÄrcat",
        yourSoftwareIsUpToDate: "Software-ul este actualizat",
        yourSoftwareVersion: "Versiunea dvs. de software: %{0}"
    },
    importData: {
        abortImportingData: "AnulaÈi importul",
        aborted: "Importul a fost abandonat",
        backupLocalDB: "Backup local database",
        confirmRestore: "Do you really want to restore all local settings?",
        dataMissing: "Importul a esuat pentru ca sursa nu a avut nici o data",
        deleteImportedData: "ÈtergeÈi datele importate",
        encodingFile: "Codare fisier",
        exportLocalSettings: "Export Local Settings",
        exportStaticSql: "Export Static SQL",
        fileDamaged: "Importul a esuat pentru ca  fisierul sursa este deteriorat",
        fileMissing: "Importul a esuat pentru ca  fisierul sursa nu exista",
        format: "Format",
        formatPath: "FormaÈi calea",
        headerMissing: "Importul a esuat pentru ca antetul fisierului lipseste",
        import: "Import",
        importAborted: "Import anulat",
        importAborting: "Importul se anuleaza",
        importFailed: "Importul a esuat din cauza unei erori necunoscute",
        importLocalSettings: "Import Local Settings",
        importPrices: "PreÈurile de import",
        imported: "Importat cu succes",
        importedWithErrors: "Importing has finished with errors. Error lines have been skipped.",
        importing: "Se Importa",
        noFormatAvailable: "FÄrÄ format disponibil",
        processing: "Prelucrare",
        processingCustomFormulas: "Prelucrarea formulelor personalizate",
        processingCustomers: "Procesarea clienÈilor",
        productsFile: "FiÈier produse",
        restoreLocalSettings: "Restore Local Settings",
        underProgress: "Importul se realizaeza",
        unknownFormat: "Importul a esuat pentru ca  fisierul sursa are un format necunoscut",
        userFormulasFile: "FiÈierul formulelor utilizator"
    },
    infoType: {
        baseDensity: "Densitatea bazei",
        baseMass: "Greutate bazÄ",
        baseUfiCode: "Base UFI code",
        baseVolume: "Volumul bazÄ",
        batchNumbersTable: "Batch numbers table",
        bfsGrade: "Clasa BFS",
        colorLab: "Laborator de culori",
        colorRgb: "Culoare RGB",
        colorRgbHex: "Culoare RGB Hex",
        colorXyz: "Culoare xyz",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantMass: "Greutate colorantÄ",
        colorantUfiCodes: "Colorant UFI codes",
        colorantVolume: "Volumul colorant",
        formulaDate: "Formula date",
        formulaDatetime: "Formula datetime",
        formulaMoreInfo: "Formula more info",
        formulaMoreInfoInternal: "Formula more info internal",
        formulaMoreInfoPrint: "Formula more info print",
        hbw: "HBW",
        isPackageGravimetric: "Este ambalaj gravimetric",
        maxColorantMass: "Greutatea maxima permisa  a colorantului",
        maxColorantVolume: "Volumul maxim permis a colorantului",
        nominalMass: "Greutatea nominala a ambalajului",
        nominalVolume: "Volumul nominal al ambalajului",
        overfillDetected: "Supra -umplere detectata",
        totalPaintDensity: "Total paint density",
        totalPaintMass: "Greutate totalÄ de vopsea",
        totalPaintVolume: "Volumul total de vopsea",
        ufiCodesTable: "UFI codes table",
        verifiedFormula: "Verified formula",
        yValue: "Valoarea Y"
    },
    initialTab: {
        favoriteFormulas: "Formule Favorite",
        lastDispensedFormulas: "Ultma Formula folosita",
        searchNewFormula: "Cauta formlua noua"
    },
    invalidBatchNumbersModal: {
        header: "Check colorants Batch number",
        info: "At least one canister is filled with (possibly) defective batch of colorant. Please do not use this batch. Empty the canister using Quick tint.",
        unknownStatus: "Unknown Batch status"
    },
    keyWords: {
        action: "action",
        add: "add",
        addition: "addition",
        additional: "additional",
        address: "address",
        admin: "admin",
        advanced: "Advanced",
        after: "after",
        afterDispensing: "after dispensing",
        alfa: "Alfa",
        all: "all",
        allow: "allow",
        alphabetically: "alphabetically",
        amount: "amount",
        api: "api",
        ask: "ask",
        autocap: "autocap",
        autotask: "autotask",
        availablePrice: "available price",
        backup: "backup",
        banner: "banner",
        barcode: "barcode",
        barcodes: "barcodes",
        base: "base",
        before: "before",
        begin: "begin",
        bfs: "bfs",
        bottom: "bottom",
        brand: "brand",
        brush: "brush",
        bug: "bug",
        button: "button",
        buy: "buy",
        cC3: "CC3",
        cM: "CM",
        calibration: "calibration",
        can: "can",
        canHandling: "can handling",
        canister: "canister",
        canisterFilling: "canister filling",
        canisterLevels: "canister levels",
        canisters: "canisters",
        cap: "cap",
        center: "Center",
        centre: "Centre",
        change: "change",
        changelog: "changelog",
        channels: "channels",
        check: "check",
        chunk: "chunk",
        chunks: "chunks",
        city: "city",
        clean: "clean",
        cleaning: "cleaning",
        clientIdentifier: "client identifier",
        close: "close",
        closest: "closest",
        code: "code",
        collect: "collect",
        color: "color",
        colorLink3: "ColorLink3",
        colorPanel: "color palette",
        colorReader: "ColorReader",
        colorant: "colorant",
        colorantConsumption: "colorant consumption",
        colorantPrice: "colorant price",
        colorants: "colorants",
        colorix: "Colorix",
        colour: "colour",
        communication: "communication",
        compare: "compare",
        competitive: "competitive",
        computer: "computer",
        config: "config",
        configuration: "configuration",
        confirm: "confirm",
        confirmation: "confirmation",
        connection: "connection",
        contactPerson: "contact person",
        control: "Control",
        copies: "copies",
        corob: "Corob",
        cost: "cost",
        country: "country",
        create: "create",
        currency: "currency",
        current: "current",
        custom: "custom",
        customers: "customers",
        daily: "daily",
        dark: "Dark",
        data: "data",
        database: "database",
        datacolor: "Datacolor",
        date: "date",
        decimals: "decimals",
        default: "default",
        delay: "delay",
        delete: "delete",
        deletion: "deletion",
        deltaE: "delta e",
        device: "device",
        devices: "devices",
        diagnosticTile: "diagnostic tile",
        dialog: "dialog",
        direct: "direct",
        disconnect: "disconnect",
        discount: "discount",
        dispense: "dispense",
        dispenser: "dispenser",
        dispensing: "dispensing",
        down: "down",
        download: "download",
        driver: "driver",
        dromont: "Dromont",
        dspProxy: "DspProxy",
        edit: "edit",
        editor: "editor",
        email: "email",
        error: "error",
        evoDriver: "EvoDriver",
        evoService: "EvoService",
        excel: "excel",
        expiration: "expiration",
        export: "export",
        eyeOne: "Eye-One",
        fF: "F&F",
        fandeck: "fandeck",
        fastFluid: "Fast & Fluid",
        file: "file",
        fill: "fill",
        fillToMax: "fill to max",
        find: "find",
        first: "first",
        flex: "Flex",
        folder: "folder",
        formula: "formula",
        formulas: "formulas",
        from: "from",
        fts5: "fts5",
        fullScreen: "full screen",
        fullText: "full-text",
        fulltext: "fulltext",
        g: "g",
        genericPricing: "generic pricing",
        hLD: "HLD",
        hard: "hard",
        hbw: "hbw",
        help: "help",
        helpCenter: "help center",
        hero: "Hero",
        history: "history",
        home: "home",
        host: "host",
        humidifier: "humidifier",
        iDD: "IDD",
        identification: "identification",
        image: "image",
        impGallon: "imp. gallon",
        impQuart: "imp. quart",
        import: "import",
        individually: "individually",
        info: "info",
        information: "information",
        initial: "initial",
        initialization: "initialization",
        initialize: "initialize",
        insert: "insert",
        install: "install",
        intellyPurge: "intelly purge",
        invalid: "invalid",
        ipAddress: "ip address",
        italtinto: "Italtinto",
        items: "items",
        keyboard: "keyboard",
        kg: "kg",
        kiosk: "kiosk",
        kioskMode: "kiosk mode",
        l: "l",
        lLD: "LLD",
        lab: "lab",
        label: "label",
        labels: "labels",
        language: "language",
        largo: "largo",
        last: "last",
        lenteq: "Lenteq",
        levels: "levels",
        license: "license",
        light: "Light",
        limit: "limit",
        link: "link",
        linux: "Linux",
        load: "load",
        lock: "lock",
        logFiles: "log files",
        logic: "logic",
        logo: "logo",
        lower: "lower",
        machine: "machine",
        machineConfiguration: "machine configuration",
        machineManagement: "machine management",
        machineName: "machine name",
        main: "main",
        maintenance: "maintenance",
        manual: "manual",
        manualAddition: "manual addition",
        manualDispensing: "manual dispensing",
        manualScan: "manual scan",
        margins: "margins",
        markups: "markups",
        mass: "mass",
        match: "match",
        measure: "measure",
        measurement: "measurement",
        measurementUnits: "measurement units",
        melody: "melody",
        message: "message",
        minimal: "minimal",
        minolta: "Minolta",
        minus: "minus",
        minutes: "minutes",
        misura: "Misura",
        ml: "ml",
        mode: "mode",
        model: "model",
        modification: "modification",
        modify: "modify",
        monthly: "monthly",
        moreInfo: "more info",
        movableTable: "movable table",
        move: "move",
        music: "music",
        myOrders: "my orders",
        name: "name",
        naming: "naming",
        nano: "Nano",
        navigation: "navigation",
        new: "new",
        nextDriver: "NextDriver",
        night: "night",
        nixPro: "Nix Pro",
        notes: "notes",
        notification: "notification",
        number: "number",
        off: "off",
        open: "open",
        order: "order",
        ordering: "ordering",
        overfill: "overfill",
        overview: "overview",
        overwrite: "overwrite",
        own: "own",
        pCPDriver: "PCPDriver",
        package: "package",
        packagePrice: "package price",
        packages: "packages",
        panels: "panels",
        parameter: "parameter",
        path: "path",
        pc: "pc",
        phone: "phone",
        phoneNumber: "phone number",
        picture: "picture",
        place: "place",
        placement: "placement",
        plug: "plug",
        plugger: "plugger",
        plugging: "plugging",
        plugin: "plugin",
        plus: "plus",
        pointOfSale: "point of sale",
        popUp: "pop-up",
        pos: "pos",
        present: "present",
        preview: "preview",
        price: "price",
        priceExport: "price export",
        priceGroup: "price group",
        priceImport: "price import",
        prices: "prices",
        pricing: "pricing",
        primaryCurrency: "primary currency",
        print: "print",
        printer: "printer",
        printing: "printing",
        problem: "problem",
        product: "product",
        productPrice: "product price",
        profiledValues: "profiled values",
        punch: "punch",
        puncher: "puncher",
        punching: "punching",
        purge: "purge",
        purgeType: "purge type",
        purgeVolume: "purge volume",
        quality: "quality",
        quick: "quick",
        quickTint: "quick tint",
        rM: "RM",
        raise: "raise",
        rcc: "rcc",
        reader: "reader",
        reboot: "reboot",
        receive: "receive",
        recirculate: "recirculate",
        recirculation: "recirculation",
        redlike: "Redlike",
        refill: "refill",
        registration: "registration",
        regular: "regular",
        removal: "removal",
        remove: "remove",
        report: "report",
        reset: "reset",
        resolution: "resolution",
        restart: "restart",
        rgb: "rgb",
        rights: "rights",
        rounding: "rounding",
        rules: "rules",
        sanTint: "SanTint",
        save: "save",
        scale: "scale",
        scan: "scan",
        scope: "scope",
        screen: "screen",
        screensaver: "screensaver",
        search: "search",
        secondaryCurrency: "secondary currency",
        select: "select",
        selectedFormula: "Selected formula",
        sell: "sell",
        sensor: "sensor",
        serialNumber: "serial number",
        server: "server",
        servers: "servers",
        service: "service",
        serviceAction: "service action",
        serviceActions: "service actions",
        serviceSoftware: "service software",
        serviceWindow: "service window",
        settings: "settings",
        shelf: "shelf",
        shortcuts: "shortcuts",
        shot: "shot",
        show: "show",
        shutDown: "shut down",
        shutdown: "shutdown",
        silent: "Silent",
        simple: "simple",
        simulation: "simulation",
        size: "size",
        skip: "skip",
        smartPurge: "smart purge",
        software: "software",
        softwareSupplier: "software supplier",
        sort: "sort",
        sound: "sound",
        spectro: "spectro",
        spectrophotometer: "spectrophotometer",
        speed: "speed",
        split: "split",
        start: "start",
        startup: "startup",
        statistics: "statistics",
        status: "status",
        stir: "stir",
        stirring: "stirring",
        street: "street",
        support: "support",
        surcharge: "surcharge",
        tab: "tab",
        tabs: "tabs",
        task: "task",
        template: "template",
        testing: "testing",
        time: "time",
        tintingManagementCenter: "tinting management center",
        to: "to",
        toDispense: "to dispense",
        tolerance: "tolerance",
        top: "top",
        total: "total",
        translation: "translation",
        turnOff: "turn off",
        turntable: "turntable",
        type: "type",
        uIDD: "UIDD",
        uSGallon: "U.S gallon",
        uSQuart: "U.S quart",
        unit: "unit",
        up: "up",
        update: "update",
        url: "url",
        user: "user",
        userGroups: "user groups",
        v1: "v1",
        v2: "v2",
        v3: "v3",
        vAT: "VAT",
        validate: "validate",
        validation: "validation",
        version: "version",
        virtual: "virtual",
        volume: "volume",
        weekly: "weekly",
        window: "window",
        windows: "Windows",
        with: "with",
        without: "without",
        xRite: "X-Rite",
        xrite: "Xrite",
        yValue: "y value",
        zipCode: "zip code",
        zoom: "zoom"
    },
    languages: {
        bg: "Ð±ÑÌÐ»Ð³Ð°ÑÑÐºÐ¸",
        cs: "ÄeÅ¡tina",
        da: "Danish",
        de: "Deutsch",
        el: "ÎÎ»Î»Î·Î½Î¹ÎºÎ¬",
        en: "English",
        es: "EspaÃ±ol",
        fr: "FranÃ§ais",
        hr: "Hrvatski",
        hu: "Magyar",
        id: "Bahasa Indonesia",
        is: "Ãsland",
        it: "Italiano",
        lt: "Lithuanian",
        lv: "Latvian",
        ms: "Melayu",
        nl: "Nederland",
        no: "Norway",
        pl: "Polski",
        pt: "PortuguÃªs",
        ro: "Romana",
        ru: "Ð ÑÑÑÐºÐ¸Ð¹",
        sk: "SlovenÄina",
        sr: "Srpski",
        sv: "Sverige",
        zh: "Chinese"
    },
    license: {
        activateLicense: "Activeaza licenta",
        activateNewLicense: "ActivaÈi o nouÄ licenÈÄ",
        checkLicenseKey: "Verifica Cheia licentei",
        companyId: "Companie",
        contactPerson: "Persoana de contact",
        copy: "Copiaza",
        country: "Tara",
        emptyCity: "Oras este o informatie ceruta",
        emptyCountry: "Tara este o informatie ceruta",
        emptyName: "Nume magazin este o informatie ceruta",
        enterIdentificationKeys: "Introdu Cheia de Identificare",
        expirationDate: "Data de expirare %{dateTime}",
        fillRegistration: "Introdu datele de Identificare",
        insertLicense: "Introdu Cheia de Licenta activata offline",
        invalidEmail: "Adresa de email invalida",
        invalidPhone: "Nr.telefon este invalid",
        itemsMarkedasterisk: "(articolele marcate cu un asterisc trebuie completate)",
        lastUpdate: "Last change %{dateTime}",
        leasedLicense: "LicenÈa Ã®nchiriatÄ",
        licenseActivated: "License already activated",
        licenseStatus: "Starea licenÈei",
        licenseWillExpire: "LicenÈa dvs. expirÄ Ã®n %{dayCount} zile",
        licenseWillExpireOneDay: "Your license expires in %{dayCount} day",
        machineInformation: "InformaÈii despre maÈinÄ",
        noLicenseAvailable: "nu existÄ licenÈÄ disponibilÄ",
        noProductsForKey: "Nu sunt produse disponibile pentru cheia de identificare",
        pointOfSale: "Punct de Vanzare",
        producer: "ProducÄtor",
        reactivate: "Reactivate",
        reactivateLicense: "Reactivate license",
        region: "Regiune",
        registerLicense: "Copiati Cheia de Activare si navigati catre",
        registrationForm: "Ãnregistrare",
        selectProduct: "Selecteaza Produs",
        serialNumber: "NumÄr de serie",
        skipNewLicense: "If you want to activate new license later you can click on Skip",
        unlimitedLicense: "LicenÈÄ nelimitatÄ",
        userId: "ID Utilizator",
        uuid: "LicenÈÄ UUID",
        versionDetails: "Detalii versiune",
        versionScope: "Version scope",
        versionType: "Version type",
        zip: "Cod postal"
    },
    login: {
        authenticate: "Authenticate",
        logIn: "Autentificare",
        loginAs: "ConectaÈi-vÄ ca un alt utilizator",
        messages: {
            incorrectUsername: "Nume Utilizator Incorect"
        },
        password: "Parola",
        username: "Nume Utilizator"
    },
    machineActionHistory: {
        actionHistory: "Istoric activitati"
    },
    machineErrors: {
        channel: "Circuit",
        code: "Cod",
        machineErrors: "Erori Masina de Colorat",
        noMachineErrors: "There are currently no machine errors",
        resetErrors: "Restare Erori"
    },
    machineSettings: {
        action: "AcÈiune",
        addAutotask: "Add autotask",
        autoCanisterIn: "Import automata canistra",
        autoCanisterOut: "Export automata canistra",
        automaticRefill: "Reumplere automatÄ",
        autotaskSettings: "SetÄri automat",
        backupConfiguration: "ConfiguraÈia dispenserului de rezervÄ",
        brushMaintenance: "ÃntreÈinerea periei",
        capMaintenance: "ÃntreÈinerea capacului",
        checkCanisterBeforeDispense: "Verifica canistra inainte de colorare",
        checkColorantBaseRules: "Check colorant base rules",
        checkMinDosableAmount: "Check the minimal tintable amount of colorants",
        checkOverfill: "Check can overfill",
        checkTotalCntAmounts: "Check total colorants amount for base paint",
        cleanAll: "Curata tot",
        computerReboot: "Repornirea computerului",
        computerShutdown: "Oprire computer",
        connectMachine: "Conectare Masina",
        days: "Zile",
        daysOfMonth: "Zilele lunii",
        devices: "Dispozitive",
        disabled: "Dezactivat",
        dispenseAndPurge: "Dispensare Èi purjare",
        dispenseOnly: "Doar dispensare",
        dispenserCleaning: "CurÄÈarea distribuitorului",
        dispensingWithErrorsEnabled: "Allow dispensing despite the validation errors",
        editAutotask: "Edit autotask",
        firstRun: "First run",
        hours: "Ore",
        humidifier: "Umidificator",
        humidifierWaterLevelMaintenance: "MenÈinerea nivelului apei umidificator",
        machineConfigurationNoCanisters: "The machine configuration contains no canisters.",
        machineName: "Denumirea Masinii de Colorat",
        machineSettings: "Setare Masina",
        manualPuncher: "Perforator manual",
        minDispensedAmount: "Valoare minim dispensatÄ",
        minutes: "Minute",
        nextRun: "UrmÄtoarea executare",
        noAutotasksSet: "No autotasks set",
        noDataAvailable: "No data available",
        noMachine: "Nici o masina conectata",
        onStart: "La Ã®nceput",
        plugger: "Priza",
        postpone: "Postpone",
        puncher: "Perforator",
        purgeAll: "PurjaÈi toate",
        purgeOnly: "Purge only",
        recirculateAll: "RecirculeazÄ toate",
        recirculateChannels: "RecirculaÈi circuitele",
        recirculationSpeed: "Viteza de recirculare",
        recirculationTime: "Timp de recirculare",
        refillAll: "ReumpleÈi toate",
        refillCanisters: "ReumpleÈi canistrele",
        runAt: "Run at",
        runDefinedDaysAt: "Zilele definite la",
        runEvery: "Executati la fiecare",
        runInDays: "Executati Ã®n zile",
        serialNum: "Serie Masina",
        settingsMachine: "Setari Masina",
        smartPurgeAll: "Purjare inteligentÄ toate",
        smartPurgeChannels: "Purjare inteligentÄ circuite",
        smartPurgeRules: "Reguli de purjare inteligentÄ",
        startType: "Tipul de pornire",
        stirAll: "AmestecaÈi toate",
        stirCanisters: "Amestecati in canistrele",
        stirringSpeed: "Viteza de amestecare",
        stirringTime: "Timpul de amestecare",
        switchPlateMaintenance: "ÃntreÈinerea plÄcii de comutare",
        theCurrentlySelectedMachine: "Selectare Masina actuala",
        threshold: "Prag",
        turntable: "MasÄ mobilÄ",
        unifyColorantBatchForMultipleCans: "Unify colorant batch for multiple cans dispensings",
        volume: "Volum",
        weekdays: "Zilele saptamanii"
    },
    mainTab: {
        acceptedFormula: "Accepted formula",
        addBuildingSite: "Add building site",
        addToFavorites: "Adauga la Favorite",
        alternativeFormulas: "Alternative formulas",
        alternativeValidFormulas: "Alternative valid formulas",
        buildingSiteSpecification: "Building site specification",
        colorantsAreInvalid: "Unul sau mai multi coloranti invalizi",
        dispensedPackages: "Ambalaje dispensate",
        dispensingInProgress: "Colorare in curs",
        dispensingIsAborted: "Dispensarea este anulatÄ",
        dispensingIsNotAvailable: "Colorarea nu este valabila",
        dispensingProgress: "%{done} din %{all}",
        editColorant: "Editeaza colorant",
        editNote: "Edit Note",
        findCompetitiveColor: "Try to find the competitive color",
        forceDispensing: "ForÈeazÄ dispensarea",
        formulaInvalidColorants: "Formula contains invalid colorants: %{colorants}",
        formulaOutOfDate: "Formula may be out of date",
        formulaProperties: "Formula properties",
        hiddenFandecks: "Hidden fandecks",
        hiddenProducts: "Hidden products",
        historicalFormulas: "Formule istorice",
        lowerDeltaNumber: "Lower delta number more accurate match",
        machineError: "Eroare a maÈinii",
        machineIsBusy: "MaÈina este ocupatÄ",
        machineNotConnected: "Masina neconectata",
        manualColorantAddition: "AdÄugare manualÄ de coloranÈi",
        modifiedFormula: "Formula este modificatÄ",
        modifiedFormulaInLab: "Formula modified in laboratory",
        newColorAfterScaling: "New color after scaling",
        newRgbNotAccuratelyMeasured: "New RGB is not accurately measured, it is only indicative",
        noBaseAvailable: "Nici o baza disponibila",
        noBuildingSiteAvailable: "No building site info is available",
        noColorantForCorrection: "No additional colorants for correction selected",
        noColorants: "Nici un colorant",
        noCustomer: "Nici un Client",
        noCustomers: "Nu existÄ clienÈi disponibili",
        noDispenseNotesAvailable: "Nu sunt disponibile note de dispensare",
        noFormulaAvailable: "You have selected a combination with no formula!",
        noFormulaSelected: "Nici o formula selectata",
        noInternalNotesAvailable: "No internal notes are available",
        noNotesAvailable: "Nu existÄ note disponibile",
        noPackageAvailable: "No package is available",
        noPackageSelected: "Nici un ambalaj selectat",
        noProductAvailable: "No product is available",
        noResultsFound: "No results found",
        openLocalFile: "Open from local database",
        openOnlineFile: "Open from the Internet",
        order: "Comanda",
        orderingIsNotAvailable: "Comanda nu este disponibilÄ",
        originalColor: "Original color",
        overAvailableLevel: "Peste nivel disponibil",
        package: "Ambalaj",
        packageIsRequired: "Package is required",
        packaging: "Packaging",
        partialUpdateReload: "Partial updates may have affected this formula. Reload this tab to see an updated data.",
        printIsNotAvailable: "Printarea nu este valabila",
        productFiles: "FiÈiere de produs",
        productFilesViewer: "Product files viewer",
        productNotAvailable: "Product '%{productName}' is not available.",
        properties: "Properties",
        regularPrice: "Pret standard",
        resetFormulaData: "NouÄ formulÄ",
        rgbOnlyIndicative: "RGB only indicative!",
        saveAsCustom: "Salveaza ca Personalizat",
        saveToStatsIsNotAvailable: "Nu este disponibilÄ salvarea Ã®n istoric",
        searchForCheaper: "Search for cheaper",
        selectFromCompetitive: "You can select color from the competitive colors.",
        specialPrice: "Pret Special",
        specialPriceVip: "Pret Special VIP",
        splitFormula: "Formula de divizare",
        withVAT: "cu TVA",
        withoutVAT: "fara TVA"
    },
    marginSettings: {
        allBases: "all bases",
        allProducts: "Toate Produsele",
        editMargin: "Editeaza Margini",
        marginAndDiscountWarning: "You have to set price calculation option for using margins and discounts.",
        marginSettings: "Setari Margini de Profit",
        marginsFor: "Margini pentru",
        markupColorants: "Adaos colorant ",
        sizeOfPackage: "Marime Ambalaj",
        valueBase: "Value base",
        valueColorant: "Value colorant"
    },
    matching: {
        actualColor: "Actual color",
        allCorrections: "All corrections",
        allTillItems: "All till the items",
        auto: "Auto",
        autoSelectAll: "Auto all",
        canStartCorrection: "Then you can start correction.",
        canStartMatching: "Then you can start matching.",
        cannotBeUsed: "Matching cannot be used.",
        changeProductAndColorants: "Try change product or colorants",
        checkConfig: "Please check the matching configuration.",
        colorCorrection: "Color correction",
        colorIsIndicative: "Color preview is only indicative.",
        colorNotAccurate: "Color may not be accurately displayed, it always depends on your monitor settings.",
        colorantInDispensedFormula: "Colorants in dispensed formula",
        confirmDispensing: "Confirm dispensing",
        connectionProblem: "Connection problem",
        correctionHistory: "Correction history",
        correctionRunning: "Correction is running",
        draftFormula: "Draft formula",
        exclude: "Exclude",
        excludeAll: "Exclude all",
        include: "Include",
        includeAll: "Include all",
        invalidProduct: "It is not possible to do the matching for product %{productName}",
        itemOnly: "Item only",
        manualColorCorrection: "Manual color correction",
        matchFormula: "Match formula",
        matchingInformation: "Matching information",
        matchingResult: "Matching result",
        matchingRunning: "Matching is running",
        matchingSearchOptions: "Matching search options",
        measurement: "Measurement",
        noCorrection: "No correction found",
        noSpectralCurveProvided:
            "The connected device cannot be used for matching because it doesn't provide spectral curve",
        notAvailableForMatching: "Not available for matching",
        originalFormula: "Original formula",
        reformulate: "Reformulate",
        reformulationRunning: "Reformulation is running",
        resultColor: "Result color",
        saveAsCustomFormula: "Save as custom formula",
        searchInProgress: "Search in progress, please wait",
        selectColorfile: "Please select colorfile.",
        selectRequiredItems: "Please select product, base, colorants and package.",
        selectedResult: "Selected result",
        spectralDataNotAvailable: "Spectral data is not available",
        startCorrection: "Start correction",
        startMatching: "Start matching",
        targetColor: "Target color",
        unsavedDraft: "Unsaved draft",
        unsavedDraftWarning: "Once you are satisfied with formula â do not forget to save your result.",
        usedForMatching: "Used for matching"
    },
    modal: {
        changeColorantUnit: "SchimbaÈi unitatea coloranÈi",
        payAttention: "Fii atent!"
    },
    module: {
        productGroups: "Product groups"
    },
    navigation: {
        globalSearch: {
            fandeckFilter: "Filtru Paletar",
            formulasOverLimit: "Aproximativ %{count} rezultate. ÃncercaÈi sÄ introduceÈi mai multe caractere.",
            foundFormulas: "%{count} formule gÄsite",
            help: "Ajutor:",
            helpText:
                "TastaÈi de ex. â%{filter}â pentru formule de cÄutare Ã®ncepÃ¢nd cu â%{formula}â, produs care Ã®ncepe cu â%{product}â Èi paletar de culori â%{fandeck}â.",
            productFilter: "Filtru Produs",
            searchInFormulas: "Cauta in Formule",
            typeMore: "VÄ rugÄm sÄ tastaÈi mai multe caractere"
        },
        menu: {
            actionHistory: "Istoric activitati",
            additionalFormulaTab: "Tab formula aditionala",
            advancedSettings: "Setari avansate",
            autotaskSettings: "SetÄri automat",
            availableDatabases: "Baze de date disponibile",
            availablePrices: "Preturi disponibile",
            bugReport: "Raport de erori",
            canisterBarcodes: "Coduri de bare Canistre",
            canisterDispensingLogic: "Logica de dispersare",
            canisterFilling: "Umplere canistre",
            canisterSettings: "SetÄri canistre",
            clientServerSettings: "Setare Server Client",
            closing: "Se inchide",
            color: "Culoare",
            colorModification: "Modificare culoare",
            colorPanel: "Color Palette Settings",
            colorRepresentation: "Reprezentare&Date culoare",
            colorSearch: "Cautare culoare",
            colorant: "Colorant",
            colorantConsumption: "Colorant Consumption",
            colorantPricing: "Colorant pricing",
            colorantRefillHistory: "Istoric reumplere colorant",
            competitiveSearch: "Cautare culoare competitiva",
            connections: "Conectari",
            currency: "Setari Moneda",
            customData: "Custom Data",
            database: "Baza de date",
            databaseCheck: "Verificare baza de date",
            databaseConnection: "Conectare Baza de Date",
            defaultValues: "Default Values",
            devices: "Devices",
            dispensingHistory: "Istoric Dispensare",
            dispensingSettings: "Setari dispersare",
            driverSettings: "Setari Driver",
            environment: "Mediu ambiant",
            environmentConfiguration: "Environment settings",
            environmentalSettings: "Setari de mediu",
            favorites: "Favorite",
            fileTransfer: "DESO File Transfer",
            formatting: "Formatting",
            formula: "Formula",
            formulaData: "Date",
            formulaModification: "Formula modification",
            formulaPanels: "Tab formula ",
            formulaSettings: "Setari Formula",
            formulaUnit: "Unitate formula",
            generalSearch: "Cautare generala",
            globalSettingsSearch: "Global Settings Search",
            helpItems: "Help settings",
            importAndExport: "Import si export",
            importAndExportData: "ImportaÈi date personalizate",
            importCustomData: "ImportaÈi date",
            initialFormulaTab: "Tab formula initiala",
            interfaceSettings: "Setari interfata",
            keyboardShortcuts: "Comenzile rapide de la tastaturÄ",
            language: "Setari Limba",
            languageSettings: "Setari limba",
            layout: "Layout",
            license: "LicenÈÄ",
            licenseData: "Date licenta",
            licenseIdentification: "Identificare licenta",
            licenseStatus: "License status",
            licenseSupplier: "Furnizor licenta",
            licenseVersion: "Versiune licenta",
            localData: "Local Data",
            machine: "Masina",
            machineActions: "Activitati Masina",
            machineAndDevices: "Machine & Devices",
            machineManagement: "Managementul masinii",
            machineSettings: "Setare Masina",
            mainSettings: "Main Settings",
            maintenance: "Mentenanta",
            marginAndDiscount: "Margin and discount",
            matchingSearchResult: "Matching search result",
            matchingSettings: "Matching Settings",
            navigationItems: "Repere de navigare",
            newFormulaWindow: "Fereastra pentru formula Noua",
            orderSearch: "CÄutare comenzi",
            orderSettings: "Setari comanda",
            packageSurcharge: "Package Surcharge",
            popUps: "Pop-Ups",
            posInfo: "POS info",
            price: "Setari Pret",
            priceManagement: "Managementul Pretului",
            priceSettings: "Setari Pret",
            pricingOptions: "Pricing Options",
            printSettings: "SetÄri tipÄrire",
            productPricing: "Product pricing",
            qualityControlSettings: "Quality Control Settings",
            quickTint: "Corare Rapida",
            rccConfig: "Configurare RCC",
            rccConnection: "Conectare RCC",
            rccSettings: "Setare RCC",
            refillSettings: "Refill Settings",
            refillingLogic: "Refilling Logic",
            registration: "Ãnregistrare",
            searchSettings: "Cautare setari",
            serverPlugins: "Server Plugins",
            serviceActions: "Activitati Server",
            settings: "Setari",
            simplifiers: "Simplificare",
            singleActions: "Actiuni singulare",
            smartPurgeRules: "Smart purge rules",
            softwareOptions: "Software Options",
            spectroSettings: "Setari Spectro",
            statistics: "Statistica",
            switchToFrontdesk: "ComutaÈi la Frontdesk",
            switchToFullRedlike: "TreceÈi la %{name}",
            switchToLight: "TreceÈi la %{name}",
            switchToMachine: "ComutaÈi la maÈinÄ",
            tabs: "Tabs & Pop-Ups",
            testBarcodes: "Test Barcodes",
            updateOptions: "OpÈiuni de actualizare",
            userManagemenet: "User Management",
            visibleUnits: "Unitati vizibile"
        },
        navBar: {
            barcode: "Cod de bare",
            help: "Ajutor",
            hideItems: "Hide products / fandecks"
        },
        notificationPanel: {
            noNotifications: "Nu existÄ noi notificÄri"
        },
        tabBar: {
            closeActive: "Inchide Pagina",
            closeAll: "Inchide toate Paginile",
            closeAllExceptActive: "Inchide toate Paginile ,mai putin cea activa",
            customFormula: "Custom Formula",
            dispensingHistory: "Istoric Dispensare",
            favorites: "Favorite",
            formulaSearch: "Formula search",
            rewriteSettings: "Re-write local settings"
        }
    },
    ordering: {
        assign: "Atribuie",
        assignment: "Atribuire",
        createdDate: "Created date",
        finishDispensing: "TerminÄ dispensarea",
        foundInOrders: "GÄsit Ã®n comenzi",
        inactiveDatabase: "Formula provine din baza de date inactivÄ sau necunoscutÄ %{0}",
        inactiveUnknownDatabase: "Formula provine din baza de date inactivÄ sau necunoscutÄ",
        newOrderReceived: "AÈi primit o nouÄ comandÄ!",
        noOrderSelected: "Nu a fost selectatÄ o comandÄ",
        release: "Eliberare",
        status: {
            accepted: "admis",
            canceled: "anulat",
            created: "creatÄ",
            done: "Terminat",
            partlyDone: "parÈial fÄcut",
            preparing: "se pregÄteste",
            unknown: "necunoscut"
        }
    },
    partialUpdates: {
        applying: "Applying partial updates",
        cantBeUsedForYourDbVersion: "Updates can't be used for this database. Please update via Helper.",
        newVersionWillBeInstalled: "It will install the new version including all available partial updates.",
        noPartialUpdatesAvailable: "No partial updates available",
        outOfDate: "out of date!",
        partialUpdates: "Partial updates",
        partialUpdatesArePreparing: "Partial updates are preparing",
        partialUpdatesAvailable: "Partial updates available!",
        preparedUpdatesMessage: "The following partial updates are prepared to be applied",
        remindMeLater: "Remind me later (after %{time} minutes)",
        swOutOfDate: "The current version of the software is",
        updateAutomatically: "If you do not response, update will start automatically in: %{time} s",
        updateToNewVersion: "Update to the newest version",
        updateWillTakeMoreTime: "The update will take more time.",
        updatesApplied: "Partial updates were successfully applied.",
        updating: "Updating"
    },
    posInfo: {
        address: "Adresa",
        contactName: "Nume de contact",
        contactPerson: "PersoanÄ de contact",
        identification: "Identificare",
        machineInformation: "Informatii despre masina",
        pos: "Punct de vÃ¢nzare",
        secondAddress: "A doua adresÄ",
        shopIdentification: "Identificarea magazinului",
        shopName: "Numele magazinului",
        url: "Url",
        zipCode: "Cod postal"
    },
    priceTypeList: {
        priceBasePurchase: "PreÈ cost pentru bazÄ",
        priceBaseSell: "PreÈ de vÃ¢nzare pentru bazÄ",
        priceBaseSellFull: "Sell full price for base",
        priceCntPurchase: "PreÈul costurilor pentru coloranÈi",
        priceCntPurchaseByColorantName: "PreÈul costului pentru %{0} colorant",
        priceCntPurchaseByName: "PreÈul costurilor pentru coloranÈi dupa nume",
        priceCntSell: "PreÈ de vÃ¢nzare pentru coloranÈi",
        priceCntSellByColorantName: "PreÈ de vÃ¢nzare pentru %{0} colorant",
        priceCntSellByName: "PreÈul de vÃ¢nzare pentru coloranÈi dupa nume",
        priceCntSellFull: "Sell full price for colorants",
        priceCntSellFullByColorantName: "Sell full price for %{0} colorant",
        priceCntSellFullByName: "Sell full price for colorants by name",
        priceGroupBarcode: "Price group barcode",
        priceMarginAll: "Marja pentru toate ambalajele",
        priceMarginPerPkg: "Marja pentru un ambalaj",
        priceSellPriceAll: "PreÈ de vÃ¢nzare pentru toate ambalajele",
        priceSellPricePerKg: "PreÈ de vÃ¢nzare pe kilogram",
        priceSellPricePerL: "PreÈ de vÃ¢nzare pe litru",
        priceSellPricePerPkg: "PreÈ de vÃ¢nzare pentru un singur ambalaj",
        priceSurchargeAll: "SuprataxÄ pentru toate ambalajele",
        priceSurchargePerPkg: "SuprataxÄ pentru un ambalaj",
        priceTintPurchaseAll: "PreÈ costuri pentru toate ambalajele",
        priceTintPurchasePerPkg: "PreÈul costului pentru un ambalaj",
        priceTintSellFullAll: "Tint sell full price for all packages",
        priceTintSellFullAllPerPackage: "Tint sell full price per package",
        priceTotalPurchaseAll: "PreÈul costului total pentru toate ambalajele",
        priceTotalPurchasePerKg: "PreÈul costului total pe kilogram",
        priceTotalPurchasePerL: "PreÈul costului total pe litru",
        priceTotalPurchasePerPkg: "PreÈul costului total pentru un ambalaj",
        priceTotalSellFullAll: "Total sell full price for all packages",
        priceTotalSellFullPerKg: "Total sell full price per kilogram",
        priceTotalSellFullPerLiter: "Total sell full price per liter",
        priceTotalSellFullPerPackage: "Total sell full price per package"
    },
    pricing: {
        allBases: "Toate bazele",
        allPackages: "Toate ambalajele",
        backup: "Backup",
        basesOfProduct: "Bases of %{productName}",
        colorantPricing: "Colorant pricing",
        export: "Export",
        import: "Import",
        packagePricing: "Package pricing",
        packageSurcharge: "Cost suplimentar ambalaj",
        packages: "Ambalaje",
        packagesOfProduct: "Packages of %{productName}",
        posCoeficient: "POS coeficient",
        priceGroupPricePerLiter: "PreÈ grup preÈ pe litru",
        priceGroups: "Grupuri de preÈuri",
        pricePerLiter: "PreÈ pe litru",
        productPricing: "Product pricing",
        purchasePrice: "Pretul de achizitie",
        purchasePricePerLiter: "PreÈ de achiziÈie pe litru",
        sellPrice: "Sell price",
        surcharge: "Cost suplimentar "
    },
    print: {
        adminRightsRequired: "Admin rights are required to edit or create a new template.",
        allowAutomaticPrint: "PermiteÈi imprimarea automatÄ",
        allowPrintAfterDispensing: "PermiteÈi imprimarea dupÄ dispensare",
        allowPrintBeforeDispensing: "PermiteÈi imprimarea Ã®nainte de dispensare",
        automaticPrint: "TipÄriÈi automat",
        choosePrinter: "Choose printer",
        chooseSettings: "Edit Settings",
        chooseTemplate: "Choose template",
        copies: "Copies",
        createTemplate: "Create template",
        createTemplateHint: "Create a new template from scratch. Save it to the templates folder and restart RCC.",
        defaultPrinter: "Imprimanta",
        defaultSettings: "Default settings",
        defaultTemplate: "Èablon implicit",
        editTemplate: "Edit template",
        editTemplateHint: "Edit %{name}. Changes will be visible after RCC restart.",
        noEditTemplate: "No template to edit",
        noPrinterSelected: "Nici o imprimanta selectata",
        noPrintersAvailable: "Nu existÄ imprimante disponibile",
        noTemplateSelected: "Nici un model selectat",
        noTemplatesAvailable: "Nu sunt disponibile Èabloane",
        numberOfCopies: "Numarul copiilor",
        openTemplateEditor: "DeschideÈi editorul de Èabloane",
        printAfterDispensing: "TipÄriÈi dupÄ dispensare",
        printAsImage: "ImprimaÈi ca imagine",
        printBeforeDispensing: "TipÄriÈi Ã®nainte de a dispensa",
        printOnRequest: "TipÄriÈi la cerere",
        printOptions: "Optiuni printare",
        printPagesAfterDispensing: "NumÄrul de exemplare dupÄ  dipensare",
        printPagesBeforeDispensing: "NumÄrul de exemplare Ã®nainte de dispensare",
        printPreview: "Previzualizare imprimare",
        printSettings: "SetÄri tipÄrire",
        printTaskLinkVariable: "Link to a variable",
        printVariable: "Print variable",
        printerName: "Numele imprimantei",
        printerOptions: "OpÈiuni imprimantÄ",
        printerSettings: "Printer Options",
        quickTintTemplate: "Èablonul Quick Tint",
        setDefaultPrinter: "SetaÈi imprimanta implicitÄ",
        setDefaultTemplate: "SetaÈi Èablonul implicit",
        setQuickTintTemplate: "SetaÈi Èablonul Quick Tint",
        showPreviewDialogBeforePrint: "Show preview dialog before print",
        template: "Format",
        templateName: "Nume Èablon",
        templateSettings: "Setari sablon"
    },
    printTemplate: {
        baseCode: "Cod  bazÄ",
        baseName: "Numele de bazÄ",
        bfs: "BFS",
        colorantType: "Colorant type",
        customerCity: "OraÈul clienÈilor",
        customerEmail: "Adresa de e-mail a clientului",
        customerName: "Numele clientului",
        customerPhone: "Telefon client",
        customerStreet: "Strada clienÈilor",
        customerZipCode: "Codul poÈtal al clienÈilor",
        destinationOfUse: "Destination of use",
        infoBfsGrade: "Clasa BFS",
        orderQrCode: "Cod QR",
        packageOrderCount: "Package order count",
        posAddress: "Adresa POS",
        posAddressSecond: "Adresa POS 2",
        posCity: "POS oraÈ",
        posContact: "Contact POS",
        posEmail: "POS e-mail",
        posPhone: "Telefon POS",
        posUrl: "POS Url",
        posZipCode: "Cod poÈtal POS",
        priceBasePurchaseWithTax: "PreÈ cost pentru bazÄ cu TVA",
        priceBaseSellWithTax: "Pret de vanzare pentru baza cu TVA",
        priceCntPurchaseWithTax: "PreÈ cost pentru coloranÈi cu TVA",
        priceCntTotalSellWithTax: "PreÈ de vÃ¢nzare pentru coloranÈi cu TVA",
        priceMarginAllWithTax: "Marja pentru toate ambalajele cu TVA",
        priceMarginPerPkgWithTax: "Marja pentru un ambalaj cu TVA",
        priceSellPriceAllWithTax: "Pret de vanzare pentru toate ambalajele cu TVA",
        priceSellPricePerKgWithTax: "PreÈ de vÃ¢nzare pe kilogram cu TVA",
        priceSellPricePerLWithTax: "PreÈ de vÃ¢nzare pe litru cu TVA",
        priceSellPricePerPkgWithTax: "PreÈ de vÃ¢nzare pentru un ambalaj cu TVA",
        priceSurchargeAllWithTax: "Cost suplimentar pentru toate ambalajele cu TVA",
        priceSurchargePerPkgWithTax: "SuprataxÄ pentru un ambalaj cu TVA",
        priceTintPurchaseAllWithTax: "Pret Costuri Colorare pentru toate ambalajele cu TVA",
        priceTintPurchasePerPkgWithTax: "Pret Costuri Colorare pentru un ambalaj cu TVA",
        priceTotalPurchaseAllWithTax: "PreÈul costului total pentru toate ambalajele cu TVA",
        priceTotalPurchasePerKgWithTax: "PreÈ total cost pe kilogram cu TVA",
        priceTotalPurchasePerLWithTax: "PreÈ total cost pe litru cu TVA",
        priceTotalPurchasePerPkgWithTax: "PreÈul costului total pentru un ambalaj cu TVA",
        productAltName: "Produs",
        recipeInline: "ReÅ£etÄ"
    },
    products: {
        bases: "Baze",
        numberOfProducts: "Numarul de Produse",
        packagesFor: "Ambalaje pentru",
        sizeOfPackage: "Marime Ambalaj"
    },
    purgeModal: {
        purgeAll: "Purjare ",
        purgeAllChannels: "Purjeaza toate circuitele",
        purgeVolume: "Volum de purjare",
        startPurge: "Start Purjare"
    },
    qualityControl: {
        darker: "Darker",
        dispensedMeasuredFormula: "Dispensed (measured) formula",
        lighter: "Lighter",
        measureDispensedFormula: "Measure dispensed formula to calculate delta E",
        moreBlue: "More blue",
        moreGreen: "More green",
        moreRed: "More red",
        moreYellow: "More yellow",
        pleaseContinueToFormulaCorrection: "Please continue to formula correction",
        qualityControlFailed: "Quality control failed!",
        qualityControlPassed: "Quality control passed"
    },
    quickTint: {
        dispensingInProgress: "Colorare in curs",
        dispensingIsNotAvailable: "Colorare nu este valabila",
        machineNotConnected: "Masina neconectata",
        noColorantsSelected: "Nici un colorant selectat",
        noPrinterAvailable: "Nu se printeaza,nici o imprimanta disponibila",
        noTemplateAvailable: "Nu se printeaza,nici un sablon",
        overMaxCanisterSize: "One or more colorant amounts are over their maximum"
    },
    quickTintSettings: {
        alphabetically: "Alfabetic",
        byCanister: "Pe canistra",
        closeAfterDispensing: "ÃnchideÈi dupÄ dispensare",
        closeBeforeDispensing: "ÃnchideÈi Ã®nainte de dispensare",
        quickTintSettings: "SetÄri Quick Tint",
        sorting: "Sortare",
        windowClosingRules: "Reguli de Ã®nchidere a ferestrei"
    },
    rccButtons: {
        abort: "abandoneaza",
        all: "toate",
        cancel: "Anulare",
        continue: "continua",
        help: "Ajutor",
        ignore: "ignora",
        no: "nu",
        noToAll: "nu tuturor",
        ok: "O.K",
        postpone: "amÃ¢na",
        resume: "reia",
        retry: "reÃ®ncercare",
        skip: "treci peste",
        yes: "da",
        yesToAll: "da la toate"
    },
    rccDialog: {
        98: "Please Verify the %{0} Base with the Barcode.",
        99: "Please Insert Base %{0} and Confirm (Click OK)",
        100: "Dispenserul da erori,vrei sa resetezi erorile?",
        101: "Dispenserul da erori,nu poti continua",
        102: "Resetare anulata,nu poti continua",
        103: "Formula contains invalid colorant: %{0}",
        104: "Formula contains invalid colorants: %{0}",
        105: "Colorant: %{0} is under warning level",
        106: "Colorants: %{0} are under warning level",
        107: "Colorant: %{0} is under critical level",
        108: "Colorants: %{0} are under critical level",
        109: "Pune cutia",
        110: "Place base can: %{0} for formula: %{1}",
        111: "Scoate cutia",
        112: "Cutie perforata?",
        113: "Erorile se reseteaza,te rog sa astepti",
        114: "Se misca raftul,te rog sa astepti",
        115: "Se perforeaza cutia,te rog sa astepti",
        116: "Dispensing formula %{0}, please wait|Package: %{1} of %{2}|Product: %{3}|Base: %{4}|Can size: %{5}",
        117: "Dispensing formula %{0}, please wait|Package: %{1} of %{2}|Product: %{3}|Base: %{4}|Can size: %{5}",
        118: "Dispensing, please wait|Package: %{0} of %{1}",
        119: "Dispensing, please wait|Package: %{0} of %{1}",
        120: "Anulare colorare,te rog sa astepti",
        121: "Validare cod de bare cutie",
        122: "Validate base can barcode|Product: %{0}|Base: %{1}|Can size: %{2}",
        123: "Procesul de colorare a fost abandonat,vrei sa-l reiei ?",
        124: "Dispenser error occurred %{0} : %{1}. Do you want to resume dispensing?",
        125: "Verifica daca cutia folosita anterior este scoasa",
        126: "Asigura-te ca folosesti o cutie noua:procesul de colorare restarteaza de la inceput",
        127: "Colorant: %{0} este sub o cantitate minimÄ de dispersare. Vrei sÄ continui Ã®n ciuda acestui avertisment?",
        128: "ColoranÈi: %{0} sunt sub o cantitate minimÄ de dispersare. Vrei sÄ continui Ã®n ciuda acestui avertisment?",
        129: "Selected formula brokes the overfill rule, total amount of colorans: %{0} %{1}, maximum allowed amounts of colorants: %{2} %{3}. Do you want to continue despite this warning?",
        130: "Dispenserul da erori,vrei sa resetezi erorile?",
        131: "Dispenserul da erori,nu poti continua",
        132: "Resetari esuate,nu poti continua",
        133: "Reteta de purjare nu exista,nu poti continua",
        134: "Reteta de purjare contine coloranti care nu se pot purja,vrei sa continui?",
        135: "Introdu o cutie pentru purjare",
        136: "Scoate cutia in care ai purjat",
        137: "Erorile se reseteaza,te rog sa astepti",
        138: "Se misca raftul,te rog sa astepti",
        139: "Se purjeaza,te rog sa astepti",
        140: "Se purjeaza,te rog sa astepti",
        141: "Anulare purjare,te rog sa astepti",
        142: "Ambalajul pentru purjare lipseÈte, verificaÈi dacÄ cutia este plasatÄ corect",
        143: "Formula de purjare conÈine elemente care nu pot fi purjate, doriÈi sÄ continuaÈi?",
        144: "AÈezaÈi cutia pentru purjare",
        145: "Se pregateste, vÄ rugÄm sÄ aÈteptaÈi",
        146: "Se finalizeaza, vÄ rugÄm sÄ aÈteptaÈi",
        150: "Se curata,te rog sa astepti",
        151: "Se curata,te rog sa astepti",
        152: "Anulare curatare,te rog sa astepti",
        160: "Recirculare,te rog sa astepti",
        161: "Recirculare,te rog sa astepti",
        162: "Anulare recirculare,te rog sa astepti",
        170: "Amestecare colorant in canistra,asteapta",
        171: "Amestecare colorant in canistra,asteapta",
        172: "Anulare amestecare colorant in canistra",
        180: "Initialzare conectare cu masina,asteapta",
        181: "Connection to the dispenser cannot be established %{0}: %{1}",
        182: "Conectarea cu masina nu se poate realiza. Vezi fisierul de logare pentru mai multe info",
        183: "Dispenserul nu are colorantul: %{0} care este definit in baza de date",
        184: "Dispenserul nu are colorantii: %{0} care sunt definiti in baza de date",
        185: "Se inchide conectarea cu masina,te rog sa astepti",
        190: "Inchide fereastra de service pentru a continua",
        200: "Resetare,te rog sa astepti",
        201: "Resetare competa,te rog sa astepti",
        202: "Initializare,te rog sa astepti",
        203: "Erorile se reseteaza,te rog sa astepti",
        205: "Se deschide Autocap,te rog sa astepti",
        206: "Se inchide Autocap,te rog sa astepti",
        207: "Se misca Autocap,te rog sa atepti",
        210: "Perforare,te rog sa astepti",
        211: "Conectare,te rog sa astepti",
        215: "Raftul se ridica,te rog sa astepti",
        216: "Raftul coboara,te rog sa astepti",
        217: "Raftul se misca,te rog sa astepti",
        220: "Moving table to refill position: %{0}, please wait",
        221: "Dispenserul se roteste pe pozitia initiala,te rog sa astepti",
        222: "Dispenserul se roteste,te rog sa astepti",
        230: "Dispenserul in functiune,te rog sa astepti",
        240: "Refill canister %{0}",
        241: "Please refill canister %{0}",
        242: "Se pozitioneaza canistra: %{0} (%{1}) in pozitia de reumplere",
        243: "Te rog re-umple canistra %{0} folosind codul de bare",
        244: "Te rog re-umple canistra %{0} folosind codul de bare",
        250: "ÃndepÄrtaÈi recipientul pentru perie, curÄÈaÈi-l Èi umpleÈi-l cu apÄ conform instrucÈiunilor",
        251: "Put back brush conainer",
        254: "Deschiderea autocap-ului",
        255: "CurÄÈaÈi autocapul conform instrucÈiunilor",
        256: "Confirmati cand s-a terminat curatarea si autocapul este din nou in loc",
        257: "Ãnchidere autocap",
        260: "ScoateÈi placa de comutare Èi curÄÈaÈi-o",
        261: "PuneÈi Ã®napoi placa de comutare",
        265: "CurÄÈaÈi maÈina cu o cÃ¢rpÄ Èi Ã®ndepÄrtaÈi tot colorantul vÄrsat sau alt lichid",
        266: "ConfirmaÈi cÃ¢nd aÈi terminat",
        270: "ReumpleÈi recipientul de apÄ al umidificatorului Èi confirmaÈi cÃ¢nd aÈi terminat",
        271: "ReumpleÈi recipientul de apÄ al umidificatorului Èi confirmaÈi cÃ¢nd aÈi terminat",
        272: "Nivelul apei este Ã®ncÄ scÄzut, verificaÈi-l din nou",
        273: "Nivelul apei este Ã®ncÄ scÄzut, verificaÈi-l din nou",
        274: "Check the water level in humidifier container",
        275: "Te rog asteapta",
        280: "Repornirea computerului",
        281: "Oprirea computerului",
        300: "Base can missing, check that the can is properly placed",
        301: "Se pregateste, vÄ rugÄm sÄ aÈteptaÈi",
        302: "Se finalizeaza, vÄ rugÄm sÄ aÈteptaÈi",
        303: "Formula nu poate fi nuanÈatÄ, deoarece conÈine colorant: %{0} care este peste cantitatea maximÄ de dispersat definitÄ pentru canistra",
        304: "Formula nu poate fi nuanÈatÄ, deoarece conÈine coloranÈi: %{0} care sunt peste cantitÄÈi maxime de dispersat definite pentru canistre",
        305: "Colorant: %{0} nu poate fi dispersat dintr-o datÄ, doriÈi sÄ Ã®mpÄrÈiÈi formula?",
        306: "ColoranÈi: %{0} nu pot fi dispersatii simultan, doriÈi sÄ Ã®mpÄrÈiÈi formula?",
        307: "Colorant: %{0} nu va fi dispersat  de masina, doriÈi sÄ  continuaÈi Èi sÄ Ã®l adÄugaÈi manual?",
        308: "ColoranÈi: %{0} nu vor fi dispersati de masina, doriÈi sÄ continuaÈi Èi sÄ ii adÄugaÈi manual?",
        309: "Formula selectatÄ este goalÄ,  utilizati baza aÈa cum este",
        310: "Nu se poate dispensa niciun colorant,  pregÄtiti bazÄ pentru adÄugarea manualÄ a colorantului",
        311: "ScoateÈi cutia de bazÄ Èi pregÄtiÈi-o pentru adÄugarea manualÄ a colorantului",
        312: "AdÄugaÈi manual %{0} %{1} de colorant: %{2}, confirmaÈi cÃ¢nd aÈi terminat",
        313: "Se dispenseaza manual formula",
        314: "Formula selectata nu intruneste regula de supra-umpere, cantitatea totala de coloranti: %{0} %{1}, cantitatea maxima admisa de coloranti: %{2} %{3}. Vrei sa continui cu toate ca ai fost avertizat?",
        315: "Scan or type UFI code of base can",
        316: "Scan or type UFI code of base can|Product: %{0}|Base: %{1}|Can size: %{2}",
        317: "Prepare colorant: %{0} for manual addition, confirm when done",
        318: "Prepare colorants: %{0} for manual addition, confirm when done",
        319: "Add manually colorant: %{0}, confirm when done",
        320: "Add manually colorants: %{0}, confirm when done",
        400: "Se va Ã®ncepe  purjare automatÄ",
        401: "Se va Ã®ncepe  purjare automatÄ",
        405: "Trebuie curatat recipientul pentru perii",
        406: "Trebuie curatat recipientul pentru perii",
        410: "Se va Ã®ncepe Ã®ntreÈinerea automatÄ a capacului",
        411: "Se va Ã®ncepe Ã®ntreÈinerea automatÄ a capacului",
        415: "Placa de comutare trebuie curÄÈatÄ",
        416: "Placa de comutare trebuie curÄÈatÄ",
        420: "Dispenserul trebuie curÄÈat",
        421: "Dispenserul trebuie curÄÈat",
        425: "ReÃ®ncÄrcarea canistrelor va fi pornitÄ",
        426: "ReÃ®ncÄrcarea canistrelor va fi pornitÄ",
        430: "Repornirea computerului a fost programatÄ",
        431: "Repornirea computerului a fost programatÄ",
        435: "Oprirea computerului a fost programatÄ",
        436: "Oprirea computerului a fost programatÄ",
        440: "CurÄÈarea dispenserului a fost programatÄ",
        441: "CurÄÈarea dispenserului a fost programatÄ",
        445: "Recircularea dispenserului a fost programatÄ",
        446: "Recircularea dispenserului a fost programatÄ",
        450: "Agitarea dispenserului a fost programatÄ",
        451: "Agitarea dispenserului a fost programatÄ",
        990: "Dispenser error occurred %{0} : %{1}. Do you want to retry the task?",
        991: "Internal error occurred: %{0}",
        200000001: "Introdu cutia",
        200000002: "Scoate cutia ",
        200000003: "Amount for '%{0}' below minimum dispense amount, continue at own risk?",
        200000004: "Reumplere %{0}"
    },
    rccDriverSettings: {
        databasePath: "Calea bazei de date",
        dispenser: "Dispenser",
        dispenserConfigurationFile: "Fisier config dispenser",
        driverPath: "Calea driver",
        extensionPath: "Calea extensie",
        folder: "Folder",
        formulaPath: "Calea formulei",
        host: "GazdÄ",
        iddPath: "Configurare fisier IDD",
        italtintoPath: "Configurare cale ltaltion",
        lldPath: "Cale LLD",
        machineType: "Tipul de masina",
        noMachineAvailable: "Nici o masina disponibila",
        protocolVersion: "Versiunea protocolului",
        rccDriverSettings: "Setari Driver",
        resultPath: "Calea rezultatului",
        save: "Salveaza setarile",
        saveSettingsWarning:
            "Atentie!Modificarile din acesata sectiune pot duce la disfunctionalitati ale dispenserului",
        serviceSwPath: "Calea  service software ",
        simulationPath: "Simulare"
    },
    rccMachineSettings: {
        allowManualColorantAddition: "Permite adÄugarea manualÄ de colorant",
        ask: "Cere",
        canHandlingOptions: "Optiuni manipulare cutie",
        checkCanBeforeDispense: "VerificaÈi cutia Ã®nainte de a dispensa",
        checkOverfill: "VerificaÈi completarea",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantPackageValidation: "Colorant package validation only",
        disable: "DezactivaÈi",
        dispenseInvalidColorants: "Dispereseaza coloranti invalizi",
        dispensingOptions: "OpÈiuni de dispersare",
        enable: "Permite",
        enableUserIdentification: "User identification",
        fullValidation: "Full validation",
        machineAccuracyWarning: "Avertisment de acuratete al maÈinii",
        machineOptions: "OpÈiuni maÈina",
        machineUnit: "Unitate masina ",
        minimalDispenseAmount: "Cantitatea minimÄ de dispersat",
        placeCanSensor: "Senzor asezare cutie",
        placeCanSensorDelay: "Senzor asezare cutie intarzie",
        rccMachineSettings: "Setari macsina",
        refillBarcodeValidation: "Refill barcode validation",
        refillBarcodeValidationCanisterAndColorant: "Validate Canister and Colorant package",
        refillBarcodeValidationColorant: "Validate only colorant package",
        refillSettings: "Refill settings",
        removeCanSensor: "ÃndepÄrtaÈi senzorul de cutie",
        removeCanSensorDelay: "ÃndepÄrtaÈi intarzierea senzor cutie",
        save: "Salveaza setarile",
        sec: "sec",
        skipPlaceCanDialog: "Salt de la fereastra asezare cutie",
        skipRemoveCanDialog: "Salt de la fereastra indepartare asezare cutie",
        splitFormula: "Split Formula",
        tmcEnabled: "ActivaÈi TMC",
        ufiCode: "UFI code",
        validateBarcodeBaseCan: "ValidaÈi codul de bare al cutiei de bazÄ",
        validateBarcodeRefill: "Refill barcode validation",
        validateColorantsDuringInit: "ValidaÈi coloranÈii Ã®n timpul iniÈializÄrii"
    },
    rccPanel: {
        actionsRunningOnDispenser: "Sunt comenzi in curs pentru dispenser",
        addLevel: "Adauga Nivel",
        addManually: "Add manually",
        barcodeNotSet: "Canister %{colorantName} (%{canisterName}) has no barcode assigned.",
        cancel: "Anulare",
        dispenseFormula: "Formula de dispersat",
        dispenserIdle: "Dispenser oprit",
        dispenserIsBusy: "Dispenser in functiune",
        dispenserIsIdle: "Dispenser oprit",
        dispenserIsReady: "Dispenserul este pregatit",
        dispensingFormula: "Se coloreaza formula",
        errorCode: "Cod de eroare",
        explanation: "ExplicaÅ£ie",
        fillToMax: "Umplere la Maxim",
        finished: "Finished",
        inProgress: "In progress",
        machineIsReady: "Masina este pregatita",
        moveToFill: "MutÄ la umplere",
        noMachineDialog: "Nici o masina conectata",
        of: "Al",
        packageSize: "Marime Ambalaj",
        placeBaseCan: "Aseaza cutia de baza",
        pleaseCheckYourMachineConnection: "VerificaÈi conexiunea la maÈinÄ.",
        pleaseRefill: "Faceti reumplere",
        solution: "SoluÅ£ie",
        subErrors: "Sub erori",
        timeToEnd: "Timp pana la final",
        tintingFormula: "Formula de colorare",
        tintingPleaseWait: "Coloreaza!Va rugam asteptati",
        validateBaseCan: "ValidaÈi cutia de bazÄ",
        waiting: "Waiting"
    },
    rccSettigns: {
        rccSettigns: "Setari RCC",
        rccUrl: "Url RCC"
    },
    rccSpectroDialog: {
        100: "Conecteaza-te la device prin Bluetooth.Asigura-te ca Bluetoth este pornit si device-ul este deschis",
        101: "Instrumentul nu a fost detectat.Vrei sa incerci din nou?",
        110: "Asigura-te ca Nano este conectat si apasa butonul de pe instrument pentru initializare",
        111: "Nano nu a fost detectat.Vrei sa incerci din nou?",
        112: "Deconecteaza Nano,asteapta 10 secunde,reconecteaza si continua",
        120: "Conectarea la dispozitiv, vÄ rugÄm sÄ aÈteptaÈi",
        121: "Instrumentul nu a fost detectat. Vrei sÄ Ã®ncerci din nou?",
        200: "Aseaza instrumentul pe partea neagra si continua sau apasa butonul de pe instrument",
        201: "Aseaza instrumentul pe partea neagra si continua ",
        202: "Aseaza instrumentul pe partea neagra si  apasa butonul de pe instrument",
        205: "Aseaza instrumentul pe partea alba si continua sau apasa butonul de pe instrument",
        206: "Aseaza instrumentul pe partea alba si continua ",
        207: "Aseaza instrumentul pe partea alba si  apasa butonul de pe instrument",
        210: "Aseaza instrumentul pe partea de diagnosticare si continua sau apasa butonul de pe instrument",
        211: "Aseaza instrumentul pe partea de diagnosticare si continua ",
        212: "Aseaza instrumentul pe partea diagnosticare si  apasa butonul de pe instrument",
        215: "Inchide capacul instrumentului si continua sau apasa butonul de pe instrument",
        216: "Inchide capacul instrumentului si continua ",
        217: "Inchide capacul instrumentului si  apasa butonul de pe instrument",
        220: "Aseaza instrumentul pe partea cu Zero si continua sau apasa butonul de pe instrument",
        221: "Aseaza instrumentul pe partea cu zero si continua ",
        222: "Aseaza instrumentul pe partea cu zero si  apasa butonul de pe instrument",
        224: "Place the instrument on calibration pad and continue or press instrument button",
        225: "Place the instrument on calibration pad and continue",
        226: "Place the instrument on calibration pad and press instrument button",
        227: "Place the instrument on calibration pad and press instrument button",
        295: "Finalizeaza calibrarea in sectiunea driver",
        296: "Instrument is not connected, do you want to open connection to it?",
        297: "Pregatire pentru calibrare,te rog sa astepti",
        298: "Se calibreaza,te rog sa astepti",
        299: "Calibrarea se finalizeaza,te rog sa astepti",
        300: "Aseaza instrumentul pe mostra si continua sau apasa butonul de pe instrument",
        301: "Aseaza instrumentul pe mostra si continua ",
        302: "Aseaza instrumentul pe mostra si  apasa butonul de pe instrument",
        303: "Instrument is not calibrated, do you want to proceed with calibration?",
        304: "Instrument is not connected, do you want to open connection to it?",
        390: "Select measure mode",
        395: "Finalizeaza masurarea in sectiunea driver",
        397: "Pregatire pentru masurare,te rog sa astepti",
        398: "Se masoara,te rog sa astepti",
        399: "Masurarea se finalizeaza,te rog sa astepti",
        498: "Descarcare masuratori,te rog sa astepti",
        499: "Descarcarea tuturor masuratorilor,te rog sa astepti",
        900: "Instrument error occurred %{0} : %{1}. Do you want to retry the task?",
        901: "Internal error occurred: %{0}"
    },
    rccSpectroSettings: {
        DatacolorColorReader:
            "Computerul trebuie sa aiba conexiune Bluetooth.Spectro trebuie sa se imperecheze cu computerul.E nevoie de Windows 10 update toamna 2018",
        DatacolorSilent:
            "Cand se foloseste modul Silent,ferestrele Datacolor sunt vazute direct in %{name}. In aceste ferestre,parametrii spectro nu pot fi schimbati",
        DatacolorUseDiagnosticTile: "Folosirea diagnostic tile imbunatateste calitatea masurarii",
        comPort: "Port Com",
        diagnosticTile: "Datacolor foloseste partea de diagnosticare",
        measureModes: "Measure modes",
        measureModesOrder: "Measure modes order",
        model: "Model",
        noSpectroAvailable: "Nici un spectro disponibil",
        rccSpectroSettings: "Setari spectro",
        save: "Salveaza setarile",
        silent: "Datacolor Oprit",
        simulationPath: "Simulare",
        spectroType: "Tip spectro",
        useProfiledValues: "UtilizaÈi valori profilate"
    },
    recirculateChannels: {
        recirculateAllChannels: "Recirculate all channels",
        recirculateChannels: "Recirculate channels",
        recirculatingSpeed: "Viteza de recirculare",
        recirculatingTime: "Timpul de recirculare",
        startRecirculating: "ÃncepeÈi recircularea"
    },
    redlikeLight: {
        finishPreviousSteps: "VÄ rugÄm sÄ terminaÈi paÈii anteriori",
        searchBySpectro: "CÄutare dupÄ spectro",
        searchFormula: "Formula de cÄutare",
        selectBase: "Select base",
        selectColor: "SelectaÈi culoarea",
        selectCustomer: "SelectaÈi clientul",
        selectFandeck: "SelectaÈi paletarul de culori",
        selectPackage: "SelectaÈi ambalajul",
        selectProduct: "SelectaÈi produsul",
        startSelectFandeck: "Start to select fandeck",
        startSelectProduct: "Start to select product",
        stepByStepProgress: "PuteÈi progresa pas cu pas",
        typeHereToSearch: "TastaÈi aici pentru a cÄuta",
        typeToFilter: "TastaÈi pentru a sorta"
    },
    restartModal: {
        computerNeedsRestart: "Computerul trebuie restartat.",
        notCompletelyTranslated:
            "Schimbarea limbii necesitÄ repornirea software-ului. Este posibil ca unele pÄrÈi ale software-ului sÄ nu fie traduse complet Ã®n acest moment.",
        restartIsRequired: "Software restart is required after the changes have been made.",
        softwareNeedsRestart: "%{name} needs restart!"
    },
    searchPanel: {
        basePlaceholder: "or type a base name",
        baseStartPlaceholder: "Start by typing a base name",
        colorCodeNamePlaceholder: "or type a formula code/name",
        colorCodeNameStartPlaceholder: "Start by typing a formula code/name",
        colorCodePlaceholder: "Identificare Cod Formula",
        colorCodeStartPlaceholder: "Identificare Cod Formulae",
        colorNameCodePlaceholder: "or type a formula name/code",
        colorNameCodeStartPlaceholder: "Start by typing a formula name/code",
        colorNamePlaceholder: "Identificare Nume Formula",
        colorNameStartPlaceholder: "Identificare Nume Formula",
        colorPreviewIsNotAvailable: "Color preview is not available. Select a fandeck to see relevant color preview.",
        fandeckPlaceholder: "Identificare Paletar de Culori",
        fandeckStartPlaceholder: "Identificare Paletar de Culori",
        formulaByColor: "Formule pe culori",
        noResultsFound: "No results found",
        packagePlaceholder: "or type a package name",
        packageStartPlaceholder: "Start by typing a package name",
        productPlaceholder: "Identificare Produs",
        productStartPlaceholder: "Identificare Produs",
        standard: "Standard",
        typeFandeckToFilter: "TastaÈi aici pentru a filtra dupÄ numele paletarului de culori",
        typeProductToFilter: "TastaÈi aici pentru a filtra dupÄ numele produsului"
    },
    sendOrderModal: {
        customNote: "NotÄ personalizatÄ",
        noCompatibleServers: "Nu existÄ servere compatibile Ã®n reÈeaua dvs.",
        orderOverview: "Prezentare generalÄ a comenzii",
        selectTargetMachine: "Select target machine",
        sendOrder: "Trimite comanda",
        sendOrderTo: "Comanda dvs. va fi trimisÄ la %{serverName}",
        targetMachine: "MaÈinÄ ÈintÄ"
    },
    server: {
        computerId: "ID computer",
        ip: "IP",
        selectServer: "Selectati unul dintre serverele valabile",
        server: "Server "
    },
    serverDialog: {
        1: "There is an error in the brand definition for your license. Please check with your provider.",
        2: "Could not process data for %{0}: %{1}",
        3: "Invalid network path.",
        4: "Invalid path type (only %{0} and %{1} types are supported)",
        5: "Error writing tinting file.",
        6: "Tinting file was created successfully.",
        7: "Could not find colorant with name: '%{0}' on row '%{1}'",
        8: "Could not find package with name: '%{0}' on row '%{1}'",
        9: "Could not find base in product with product name: '%{0}' and base name: '%{1}' on row '%{2}'",
        10: "Could not find base in product package with product name: '%{0}', base name: '%{1}' and package name: '%{2}' on row '%{3}'",
        11: "Could not parse price value: '%{0}' on row '%{1}' in sheet '%{2}'",
        12: "Preparing bases data, please wait",
        13: "Preparing bases in products data, please wait",
        14: "Preparing base packages data, please wait",
        15: "Preparing colors data, please wait",
        16: "Preparing colors in fandecks data, please wait",
        17: "Preparing fandecks data, please wait",
        18: "Preparing data for global search, please wait",
        19: "Preparing products data, please wait",
        30: "Partial updates can't be applied on database '%{0}'. Update your software to the latest version. Minimal required version is '%{1}'.",
        31: "Partial updates can't be applied on database '%{0}'. Database versions doesn't match. Contact your technical support.",
        32: "Partial updates can't be applied on database '%{0}'. Database structure version doesn't match. Contact your technical support.",
        33: "Partial updates can't be applied on database '%{0}'. The update is corrupted. Contact your technical support.",
        34: "Unknown error occurred during partial update. If this error repeats contact your technical support.",
        35: "No partial updates available. Please check your internet connection or contact your technical support.",
        36: "Prepared partial updates for database '%{0}' are for newer version of Redlike. Update your Redlike to the latest version. Minimal required version is '%{1}'.",
        37: "Partial updates can't be prepared. There is not enough space on the drive. Minimal required space is 20 GB.",
        38: "Partial updates can't be applied on database '%{0}'. The update is invalid. Contact your technical support.",
        39: "Partial updates can't be applied on database '%{0}'. The update can't be downloaded. Contact your technical support.",
        40: "Partial updates can't be applied on database '%{0}'. Downloaded file is corrupted. Contact your technical support."
    },
    serverPlugins: {
        activeServerPlugins: "Active server plugins",
        currentlyActive: "Active plugins curente",
        plugin: "Plugin",
        pluginName: "Plugin name",
        statusActive: "Active",
        statusInactive: "Unactive"
    },
    serviceActionsSettings: {
        canisterLevel: "Nivel  canistra",
        capClose: "Ãnchide",
        capMiddle: "Mijloc",
        capOpen: "Deschis",
        cleanAllChannels: "CurÄÈaÈi toate circuitele",
        cleanChannels: "CurÄÈaÈi circuitele",
        computer: "Calculator",
        computerReboot: "Repornirea computerului",
        computerShutdown: "Oprire computer",
        connectMachine: "ConectaÈi maÈina",
        general: "General",
        initialize: "iniÈializeazÄ",
        noMachineIsConnected: "Nicio maÈinÄ nu este conectatÄ",
        plug: "Priza",
        plugger: "Priza",
        punch: "Punch",
        puncher: "puncher",
        purgeChannels: "Purjeaza circuitele",
        recirculate: "Recirculare",
        recirculateAllChannels: "RecirculaÈi toate circuitele",
        recirculateChannels: "RecirculaÈi canalele",
        serviceActions: "AcÈiuni de service",
        setCanisterLevel: "Set canister level",
        shelfDown: "Raft jos",
        shelfUp: "Raft sus",
        showServiceWindow: "AratÄ fereastra de service",
        smartPurgeAllChannels: "Smart purge all channels",
        smartPurgeChannels: "Smart purge channels",
        startErrorReset: "ÃncepeÈi resetarea erorii",
        startHardReset: "ÃncepeÈi resetarea hard",
        startReset: "ÃncepeÈi resetarea",
        stirAllCanisters: "AgitaÈi toate canistrele",
        stirCanisters: "AgitaÈi canistrele",
        stirCanistersMore: "AgitaÈi canistrele"
    },
    spectroMode: {
        eggshell: "Eggshell",
        flat: "Flat",
        gloss: "Gloss",
        matt: "Matt",
        matte: "Matte",
        pearl: "Pearl",
        satin: "Satin",
        selectGlossLevel: "Compare the color sample to the gloss scale and select gloss level",
        semiGloss: "Semi-Gloss"
    },
    spectroTab: {
        bestMatch: "The best match",
        calibrate: "Calibreaza",
        calibrateInstrument: "Calibrate instrument",
        connectDevice: "Conecteaza Aparatul",
        connectedTo: "Conectat la",
        connectingDevice: "Se conecteaza aparatul",
        deselectAll: "DeselectaÈi toate",
        deviceCalibrated: "Your device has been calibrated and you can start measuring",
        deviceIsNotCalibrated: "Aparatul Nu este Calibrat",
        eraseResult: "Erase result",
        filter: "Filtreaza",
        foundInFormulas: "GasesteInFormule",
        inactiveSpectro: "The Spectro function is inactive for selected brand.",
        instrumentCalibration: "Your instrument needs to be calibrated.",
        manualInput: "Manual input",
        measure: "Measure",
        measurementResult: "Rezultatul mÄsurÄrii",
        noFilters: "Nu existÄ filtre disponibile",
        noFormulas: "No formulas found.",
        noSelectedSpectro: "Nici un spectro selectat",
        notSelected: "Nu a fost selectat",
        pressConnectButton: "Apasa Butonul Conectare",
        searchFormulas: "Cauta Formula",
        selectSpectro: "SelectaÈi spectro",
        showDetails: "Arata detaliile",
        skipCalibration: "Skip calibration",
        spectroIsConnected: "Spectro este conectat",
        spectroIsReady: "Spectro este gata",
        spectroReady: "Dispozitivul este gata pentru sarcini suplimentare",
        startCalibrateNow: "Start calibrate now",
        startMeasureText: "Nu s-a gasit nici o formula",
        tolerance: "Delta E (CIE 2000) ",
        toleranceOfDevitation: "ToleranÈÄ Delta E (CIE 2000)"
    },
    statisticsTab: {
        allRecords: "All records",
        customPackageName: " Personalizate %{1} %{2}",
        deleteSelectedRecords: "Sterge Inregistrarile Selectate",
        exportHistory: "Exporta istoric",
        finishFormula: "Termina formula",
        foundInFormulas: "Gasit In Formule",
        hideHiddenRecords: "Nu afiÈaÈi Ã®nregistrÄri ascunse",
        hideSelectedRecord: "AscundeÈi Ã®nregistrarea selectatÄ",
        historicalFormula: "Historical formula",
        onlyFiltered: "Only filtered",
        restoreSelectedRecord: "RestauraÈi Ã®nregistrarea selectatÄ",
        showAllRecords: "AfiÈaÈi toate Ã®nregistrÄrile",
        standardFormula: "Standard formula",
        unknownFormula: "Unknown formula"
    },
    stirCanisters: {
        selectCanisters: "SelectaÈi canistre",
        startStirring: "ÃncepeÈi sÄ agitaÈi",
        stirAllCanisters: "Stir all canisters",
        stirCanisters: "Stir canisters",
        stirringSpeed: "Viteza de agitare",
        stirringTime: "Timp agitare"
    },
    stock: {
        addColorant: "Add colorant...",
        addColorantPackagesToStock: "Add colorant packages to stock",
        addPackagesToStock: "Add packages to stock",
        addedToStock: "Added to stock",
        allDatabases: "All databases",
        checkStockPackageInventory: "If you used package from stock, please check if your stock inventory is valid.",
        clearAllItems: "Clear all items",
        colorantInventory: "Colorant inventory",
        colorantsStockInventory: "Colorants stock inventory",
        confirmSendingOrder: "Confirm sending order",
        consumptionPrediction: "Consumption prediction for the next %{weeks} weeks",
        createOrder: "Create order (%{sum})",
        expirationDate: "Expiration date",
        inDelivery: "In delivery",
        manualOrder: "Manual order",
        manualOrderProgress: "Step %{step}/%{total}",
        noPackagesFoundInStockForColorant: "There are no packages in stock for this colorant.",
        onStock: "In stock",
        orderSummary: "Order summary",
        prediction: "Prediction",
        removePackageFromStock: "Remove %{colorantName} package from stock",
        removePackageNameFromStock: "Would you like to remove one %{packageName} package from stock?",
        scanBarcodeOrSelectColorant: "Scan barcode from package or select colorant",
        selectPackageToRemove: "Select package to remove",
        sendConfirmed: "Send confirmed",
        setAmountsByPrediction: "Set amounts by prediction",
        sortByColorantName: "Sort by colorant name",
        sortByOrderNeed: "Sort by need to order",
        sortByStockLevel: "Sort by stock level",
        toOrder: "To order"
    },
    testBarcode: {
        noItemAssigned: "Niciun articol nu este atribuit codului de bare %{code}",
        pleaseScanBarcode: "Please scan the barcode of base, product, package or another items",
        testBarcodes: "Test barcodes"
    },
    ticketing: {
        answer: "Answer",
        answered: "Answered",
        chooseType: "Choose type",
        closeRequest: "Close request",
        comment: "Comment",
        create: "Create",
        createNewTicket: "Create new ticket",
        formulaAttached: "The requested formula is attached to the answer. Click the %{loadFormula} button to open it.",
        formulaClaim: "Formula claim",
        formulaRequest: "Formula request",
        formulaUnrealizable: "The requested formula is unrealizable.",
        newTicket: "New ticket",
        noPosInfoFound: "POS information (name, city) not found",
        noTicketSelected: "No ticket selected",
        openTicket: "Open ticket",
        posName: "POS name",
        posted: "Posted",
        request: "Request",
        requestDate: "Request date",
        requestId: "Request ID",
        resolvedBy: "Resolved by",
        responseDate: "Response date",
        saveToCustomFormula: "Save to custom formula",
        sending: "Sending",
        service: "Service",
        successfulCreation: "Ticket successfully created. Sending...",
        ticketAnswered: "A ticket has been answered.",
        ticketDelivered: "A ticket has been delivered.",
        ticketId: "Ticket ID",
        ticketType: "Ticket type",
        waitingForAnswer: "Waiting for answer"
    },
    tutorial: {
        last: "Ultimul",
        next: "Urmatorul"
    },
    ufiCodeModal: {
        currentStatus: "Current Status",
        detailedInfoForColorant: "Detailed info for colorant %{colorantName}",
        userSetUfiCode: "User set UFI code, current value"
    },
    ufiCodeSettings: {
        baseUfiCodeValidation: "Base UFI code validation",
        confirmColorantRefilling: "Confirm colorant refilling",
        enableUfiCodes: "Enable UFI codes",
        printUfiCode: "Print if amount of colorant is over",
        printUfiCodePercentage: "Print percentage if amount of colorant is over",
        scanOrTypeUfiCode: "Scan or type UFI code",
        scanOrTypeUfiCodeOfBase: "Scan or type UFI code of base can",
        ufiCodesByPercentage: "Use UFI codes by percentage",
        ufiCodesFromDatabase: "Use UFI codes from the database",
        ufiCodesFromLastFilling: "Use UFI codes from the last filling"
    },
    userSettings: {
        addUser: "AdÄugaÈi utilizator",
        assignedUserGroups: "Grupuri de utilizatori alocaÈi",
        availableUserGroups: "Grupuri de utilizatori disponibili",
        barcode: "coduri de bare",
        confirmNewPassword: "ConfirmÄ parola",
        editPassword: "EditeazÄ parola",
        editUser: "Editare utilizator",
        enableAutoLogin: "ActivaÈi autentificarea automatÄ",
        newPassword: "ParolÄ NouÄ",
        noChange: "Nu e nici o modificare care sa fie salvata",
        oldPassword: "Parola veche",
        password: "Parola",
        passwordsDoNotMatch: "Parola nu se potriveste",
        restoreUser: "This user is deleted. Do you want to restore him?",
        userGroup: "User Group",
        userGroups: "Grupuri de utilizatori",
        userManagement: "Managementul utilizatorilor",
        userSettings: "User settings",
        username: "Nume de utilizator",
        usernameIsMissing: "Lipseste numele utilizatorului"
    },
    warningMissingDataModal: {
        continue: "Same data is missing, do you want continue?",
        notFoundBase:
            "This product base is not available. Confirm and be careful to get compatible product base from shelf or cancel this order.",
        notFoundProduct:
            "This product is not available. Confirm and be careful to get compatible product from shelf or cancel this order."
    },
    weekdays: {
        friday: "Vineri",
        monday: "Luni",
        saturday: "SÃ¢mbÄtÄ",
        sunday: "DuminicÄ",
        thursday: "Joi",
        tuesday: "MarÅ£i",
        wednesday: "Miercuri"
    },
    welcome: {
        availableDatabase: "Server cannot connect to database. Please check your database configuration.",
        availableDatabaseLocalError: "Eroare la conectarea la baza de date localÄ (fiÈier greÈit, parolÄ nevalidÄ)",
        availableDatabaseLocalMissing: "FiÈierul date de  bazÄ localÄ lipseÈte",
        availableDatabaseLocalUpdate: "Baza de date localÄ trebuie actualizatÄ la versiunea mai nouÄ",
        availableDatabaseMainAndLocalError:
            "Error during connecting to both main and local databases (wrong file, invalid password)",
        availableDatabaseMainAndLocalMissing: "FiÈierele principale Èi locale de date lipsesc",
        availableDatabaseMainAndLocalUpdate:
            "AtÃ¢t bazele de date principale, cÃ¢t Èi cele locale trebuie actualizate la versiunea mai nouÄ",
        availableDatabaseMainError: "Eroare la conectarea la baza de date principalÄ (fiÈier greÈit, parolÄ nevalidÄ)",
        availableDatabaseMainMissing: "FiÈierul principal al bazei de date lipseÈte",
        availableDatabaseMainPartialUpdate: "Main database needs to be updated to the newer version via partial update",
        availableDatabaseMainPartialUpdateAndLocalUpdate:
            "Main database needs to be updated to the newer version via partial update and local database needs to be updated to the newer version",
        availableDatabaseMainUpdate: "Baza de date principalÄ trebuie actualizatÄ la versiunea mai nouÄ",
        closing: "Software-ul se Ã®nchide",
        compatibility:
            "Please check the version of your server. Your client is compatible only with server %{0} or higher.",
        compatibilityCheck: "Verificare compatibilitate in curs",
        compatibilityDatabase: "Verificare versiune baza de date",
        connectingServer: "Conectare server %{ip}",
        databaseCompatibility: "Baza de date nu este compatibilÄ cu software-ul curent",
        databasesCompatibility: "Bazele dvs. de date nu sunt compatibile cu software-ul curent",
        licenseVerification: "Verificare licenta in curs",
        loading: "Incarcare",
        lostConnection: "Conectare la server pierduta",
        moduleMessage:
            "Pay attention to module selection, because future change of module will be available only for privileged users.",
        refresh: "ReÃ®mprospÄteaza",
        restoring: "Restabilire conexiune",
        selectModule: "VÄ rugÄm sÄ selectaÈi unul dintre modulele disponibile.",
        stopUpdate: "OpriÈi actualizarea",
        updateDatabase: "ActualizeazÄ baza de date",
        updatingDatabase: "Baza de date se actualizeazÄ",
        updatingDatabases: "Bazele de date se actualizeazÄ",
        updatingWarning: "Database structure is being updated to the newest version, please wait.",
        updatingWarningInfo:
            "Do not close this window as it would result in the necessity to do the update from scratch."
    }
};
